<template>
  <!--新建/审批内容-->
  <div id="editContList" >
    <van-overlay :show="showoverlay" z-index="99999999999999">
        <div class="wrapper" >
          <div class="block">
            <img src="../../../assets/loading.gif" height="144" width="192"/>
            <span style="font-size: 16px;position: relative;top:-50px">AI推荐标签获取中</span>
          </div>
        </div>
      </van-overlay>

    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto">
          <p
            style="bottom: 0"
            class="font16 bottom"
          >{{previewContentId === 0 ? '新建':'编辑'}}</p>
        </div>
        <div style="width: auto">
          <button
            class="cancelButtonTwo"
            @click="allReturn"
          >返回</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace" >
      <div style="align-items: flex-start" class="d_flex m_t_10 m_b_10">
        <div style="width: calc(100% - 290px)">
          <ul class="allUL">
            <li>
              <span style="font-size:16px;"><i class="colorRed m_r_5">*</i>标题</span>
              <input maxlength="64" v-model="postModel.TitleCN" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -37px;" placeholder="0/64" />
            </li>
            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 108px;">摘要</span>
              <input type="text" v-model="postModel.SummaryCN" class="allInput" style="width: calc(100% - 98px);margin-left: -37px;" placeholder="0/100" maxlength="100" />
            </li>
            <li v-show="isTwoNext">
              <span style="font-size:16px;width: 120px;"><i class="colorRed m_r_5">*</i>标签</span>
              <!-- @focus="openTagModal" -->
              <input @focus="beforOpenTag" type="text" v-model="postModel.tags" class="allInput" style="width: calc(100% - 110px);margin-left: -37px;" placeholder="0/100" maxlength="100" />
            </li>




            <div v-show="isTwoNext">
              <li>
              <input v-model="postModel.articleType" type="radio" value="F" class="allRadio" id="allPicture" name="allPicture" :disabled="postModel.firstSubmitTime?true:false" />
              <label for="allPicture"></label><abbr>武田推文</abbr>
              <input v-model="postModel.articleType" type="radio" value="H" class="allRadio" id="halfPicture" name="halfPicture" :disabled="postModel.firstSubmitTime?true:false"/>
              <label for="halfPicture"></label><abbr>腾讯推文</abbr>
              <input v-if="postModel.Id == 0" v-model="postModel.articleType" type="radio" value="FH" class="allRadio" id="allAndHalfPicture" name="allAndHalfPicture" />
              <label v-if="postModel.Id == 0" for="allAndHalfPicture"></label><abbr v-if="postModel.Id == 0">武田&腾讯</abbr>
            </li>
            <li class="colorRed" style="padding-left: 12px;">*创建单推文章选择“武田推文”，创建群推文章选择“腾讯推文”；一篇文章同时创建为单推和群推，请选择“武田&腾讯”</li>
            <li class="colorRed" style="padding-left: 12px;">提交后，文章类型不可退回修改，请谨慎提交</li>
            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 148px;">话题</span>
                <abbr class="d_i">
                  <allSelect :chooseData="topciList" :needReturn="'id'" :placeholder="'话题'" :matchValue="'topicName'" :showValue="'{{topicName}}'" v-model="postModel.topicId">
                  </allSelect>
                </abbr>
            </li>


            
            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 148px;">文章板块</span>
                <abbr class="d_i">
                  <allSelect :chooseData="countyInfoList" :needReturn="'key'" :placeholder="'文章集锦'" :matchValue="'listValue'" :showValue="'{{listValue}}'" v-model="postModel.countyInfo">
                  </allSelect>
                </abbr>
             
              <!-- <input v-model="postModel.countyInfo" type="radio" value="False" class="allRadio" id="notCounty" name="countyRadio" />
              <label for="notCounty"></label><abbr>文章集锦</abbr>
              <input v-model="postModel.countyInfo" type="radio" value="True" class="allRadio" id="isCounty" name="countyRadio" />
              <label for="isCounty"></label><abbr>县域专区</abbr> -->
            </li>

            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 148px;">是否允许转发</span>
              <input v-model="postModel.iscanfoward" id="iscanfoward" class="allSwitch" type="checkbox">
              <label for="iscanfoward"></label>
            </li>


            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 148px;">是否为商业材料</span>
              <input v-model="isSynCOCE" @change="changeSyncOCE" id="isSynC_OCE" class="allSwitch" type="checkbox">
              <label for="isSynC_OCE"></label>

              <span v-if="postModel.synC_OCE === 1" style="font-size:16px;width: 40px;"></span>
              
              <input v-if="postModel.synC_OCE === 1" v-model="postModel.isPromotion" type="radio" value="False" class="allRadio" id="Promotion" name="PromotionRadio"  />
              <label v-if="postModel.synC_OCE === 1" for="Promotion"></label><abbr v-if="postModel.synC_OCE === 1">Promotion材料</abbr>
              <input v-if="postModel.synC_OCE === 1" v-model="postModel.isPromotion" type="radio" value="True" class="allRadio" id="NonPromotion" name="PromotionRadio" />
              <label v-if="postModel.synC_OCE === 1" for="NonPromotion"></label><abbr v-if="postModel.synC_OCE === 1">Non-promotion材料</abbr>

              <span v-if="postModel.synC_OCE === 1" style="font-size:16px;width: 40px;"></span>
              <span v-if="postModel.synC_OCE === 1" style="font-size:16px;width: 148px;">是否引用医学部文章</span>
              <input v-if="postModel.synC_OCE === 1" v-model="isSynCDMA" @change="changeSyncDMA" id="isSynC_DMA" class="allSwitch" type="checkbox">
              <label v-if="postModel.synC_OCE === 1" for="isSynC_DMA"></label>
              
            </li>
            <li class="colorRed" style="padding-left: 12px;"><span>*PromoMats过审材料均属于商业材料</span><span v-if="postModel.synC_OCE === 1" style="margin-left:140px">*Promotion材料：审批编号开头为“C-APROM”；Non-promotion材料：审批编号开头为“C-ANPROM”</span>  </li>

            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 72px;"><i class="colorRed m_r_5" v-if="postModel.synC_OCE === 1">*</i>品牌</span>
              <!-- <allSelect class="d_i v_m" :needSearch="true" :chooseData="brandList" :needReturn="'brandCode'" :placeholder="'请选择品牌'" :matchValue="'brandCN'" :showValue="'{{brandCN}}'"  v-on:on-change="getBrand">
              </allSelect> -->
              <newSelect :width="'300px'" class="d_i v_m" :showSearch="true" :multiple="true" :chooseData="brandList" :needReturn="'brandCode'"  v-on:selectValue="getMulBrand($event)" :placeholder="'请选择品牌'" :matchValue="'brandCN'" :showValue="'{{brandCN}}'" v-model="postModel.brandCode" :borderLine="'#e1e1e1'">
              </newSelect>
            </li>

            <li :style="(postModel.articleType == 'H' || postModel.articleType == 'FH')? '' : 'padding-left: 12px;'" v-if="postModel.articleType == 'H' || postModel.articleType == 'FH'">
              <!--<span style="font-size:16px;width: 160px;"><i class="colorRed m_r_5" :style="postModel.articleType == 'H' ? '' : 'display:none;'">*</i>是否显示原作者</span>-->
              <span style="font-size:16px;width: 160px;"><i class="colorRed m_r_5" style="visibility: hidden">*</i>是否显示原作者</span>
              <input v-model="postModel.isshowAuthor" id="isshowAuthor" class="allSwitch" type="checkbox">
              <label for="isshowAuthor"></label>
            </li>
            <li v-if="postModel.isshowAuthor && (postModel.articleType == 'H' || postModel.articleType == 'FH')" style="padding-left: 12px;">
              <span style="font-size:16px;">原作者</span>
              <input v-model="postModel.author" class="allInput" style="width: calc(100% - 110px);margin-left: -37px;" placeholder="0/32" maxlength="32" type="text" />
            </li>
            <li :style="(postModel.articleType == 'H' || postModel.articleType == 'FH') ? '' : 'padding-left: 12px;'" v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH')">
              <span style="font-size:16px;width: 160px"><i class="colorRed m_r_5" :style="(postModel.articleType == 'H' || postModel.articleType == 'FH') ? '' : 'display:none;'">*</i>是否显示阅读原文</span>
              <input v-model="postModel.isshowurl" id="isshowurl" class="allSwitch" type="checkbox">
              <label for="isshowurl"></label>
            </li>

             <!-- 选择文章 -->
             <li v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH') && postModel.isshowurl" class="colorRed" style="padding-left: 12px;">*请从系统已提交文章中选择一篇文章作为原文，如果是第三方的文章地址，请直接输入原文地址</li>
            <li v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH') && postModel.isshowurl" style="padding-left: 12px;">
              <span style="font-size:16px;">请选择原文</span>
              <input @focus="openArticalModal" v-model="postModel.sourceArticleTitle" class="allInput" style="width: calc(100% - 110px);margin-left: -37px;" placeholder="0/32" maxlength="32" type="text" />
            </li>
            <li v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH') && postModel.isshowurl" style="padding-left: 12px;">
              <span style="font-size:16px">原文地址</span>
              <input @change="changeSourceUrl" :disabled="!postModel.isshowurl" type="text" v-model="postModel.sourceUrl" class="allInput" style="width: calc(100% - 110px);margin-left: -37px;" placeholder="0/100" maxlength="100" />
            </li>
            <li v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH') && postModel.isshowurl" class="colorRed" style="padding-left: 12px;">*如果原文地址不填，则默认用服务器地址</li>
            <li :style="(postModel.articleType == 'H' || postModel.articleType == 'FH') ? '' : 'padding-left: 12px;'" v-if="(postModel.articleType == 'H' || postModel.articleType == 'FH') && postModel.isshowurl">
              <!--<span style="font-size:16px;width: 160px;"><i class="colorRed m_r_5" :style="postModel.articleType == 'H' ? '' : 'display:none;'">*</i>是否允许评论</span>-->
              <span style="font-size:16px;width: 160px;"><i class="colorRed m_r_5" style="visibility: hidden">*</i>是否允许评论</span>
              <input v-model="postModel.need_open_comment" id="need_open_comment" class="allSwitch" type="checkbox">
              <label for="need_open_comment"></label>
            </li>
            <li style="padding-left: 12px;">
              <span style="font-size:16px;width: 148px;">是否播放语音</span>
              <input v-model="postModel.isAudio" id="isAudio" class="allSwitch" type="checkbox" @change="changeRadio">
              <label for="isAudio" style="margin-right: 20px;"></label>
              <div style='display: inline;' v-if="showPlayRadio">
                <input v-model="postModel.audioType" type="radio" value="F" class="allRadio" id="radio1" name="radio1" />
                <label for="radio1"></label><abbr>全文播放</abbr>
                <input v-model="postModel.audioType" type="radio" value="P" class="allRadio" id="radio2" name="radio2" />
                <label for="radio2"></label><abbr>仅播放部分内容</abbr>
              </div>
            </li>
            <li v-if="showPlayRadio && postModel.audioType === 'P' " style="padding-left: 12px;">
              <span style="font-size:16px"></span>
              <textarea
                v-model="postModel.audioContent"
                placeholder="请输入播放文本内容"
                style="width: 40vw; min-height: 50px; padding: 10px; font-size: 16px; line-height: 16px; min-width: 300px; max-width: 1200px;"
              ></textarea>
            </li>
            <li >
              <span style="font-size:16px;"><i class="colorRed m_r_5" >*</i>审核编号</span>
              <input v-model="postModel.auditNo" class="allInput" style="width: calc(100% - 110px);margin-left: -37px;" placeholder="0/32" maxlength="32" type="text" />
            </li>

            <li>
              <span style="font-size:16px;width: 82px;"><i class="colorRed m_r_5">*</i>批准日期</span>
              <cander v-model="postModel.activeTime"  :className="'allInput'" placeholderName="批准日期"  class="d_i thisCanderDiv" style="vertical-align: middle"></cander>
            </li>
            <li >
              <span style="font-size:16px;width: 82px;"><i class="colorRed m_r_5">*</i>到期日期</span>
              <cander :disabled="!postModel.activeTime" v-model="postModel.inActiveTime"  :className="'allInput'"  :minDate="postModel.activeTime" placeholderName="到期日期"  class="d_i thisCanderDiv" style="vertical-align: middle"></cander>
            </li>
            <li :style="(postModel.articleType == 'F' || postModel.articleType == 'FH') ? '' : 'padding-left: 12px;'">
              <span style="font-size:16px"><i class="colorRed m_r_5" :style="(postModel.articleType == 'F' || postModel.articleType == 'FH') ? '' : 'display:none;'">*</i>声明</span>
              <textarea
                class="allTextarea"
                v-model="postModel.declared"
                disabled
                placeholder="请输入声明"
                style="width: calc(100% - 110px);margin-left: -37px;"
              ></textarea>
            </li>

            
            <li>
              <span style="font-size:16px"></span>
              <button style="margin-left: -37px;" @click="addSur(1)" class="redButtonTwo">添加调研</button>
              <abbr style="margin-left: 20px" v-if="postModel.researchId">{{surName}}</abbr>
              <abbr @click="delSur" v-if="postModel.researchId" style="display: inline-block;margin-left:10px;transform: rotate(45deg);border-radius: 100px;border: 1px solid #333;width: 20px;height: 22px;line-height: 20px;text-align: center;font-size: 20px">+</abbr>
            </li>

            <li style="padding-left: 12px;min-height: 31px;display: flex;align-items: center;"  v-if="postModel.articleType == 'F' || postModel.articleType == 'FH'">
              <span style="font-size:16px;width: 148px;">是否定时发布</span>
              <input v-model="postModel.willpublish" id="willpublish" class="allSwitch" type="checkbox" >
              <label for="willpublish"></label>
<!-- @change="changepublishRadio"  v-model="postModel.pushPlanTime" -->
              <div style='display: inline;' v-if="postModel.willpublish">
              <cander :noSec="true" :showTimePicker="true" v-model="postModel.willpublishtime" :className="'allInput'" :placeholderName="'请选择时间'"  class="d_i m_l_10" style="vertical-align: middle;position: relative;z-index:9999;"></cander>
              
              </div>
<span v-if="postModel.articleType == 'FH'" class="colorRed" style="padding-left: 12px;">*该功能仅支持武田推文</span>
            </li>

            </div>

          </ul>
        </div>
        <div style="text-align: center">
          <!--          <input @change="signalUpload" type="file" id="inFile" class="coverFile" accept="image/*"/>-->
          <input @change="clopuploadImg($event,2)" type="file" id="inFile" class="coverFile" accept="image/*"/>
          <label style="width: 225px;height: 125px;" for="inFile">
            <div v-if="postModel.CoverCN !== 0 && postModel.CoverCN !== null">
              <img :src="baseUrl + '/api/Article/file/' + postModel.CoverCN + '?token=' + token" width="225" height="125" style="border-radius: 8px"/>
            </div>
            <div v-else style="margin-top: 20px">
              <i class="icon iconfont iconshangchuan1 colorDH" style="font-size: 50px"></i>
              <p v-if="CNmode" class="m_t_10 colorGray">点击上传封面图片</p>
              <p v-else class="m_t_10 colorGray">Cover Picture</p>
            </div>
          </label>
          <div v-if="CNmode">
            <span class="colorGray"><i class="colorRed m_r_5">*</i>请上传900*383比例的图片</span>
          </div>
          <div v-else>
            <span class="colorGray"><i class="colorRed m_r_5">*</i>Recommended size: 900*383</span>
          </div>
        </div>
      </div>
      <div class="input">
        <div class="showUEplace" :style="{'display': CNmode ? 'block' : 'none'}">
          <nav style="margin-left: -90px" class="m_l_10 m_b_5 "><i class="colorRed m_r_5">*</i><abbr class="font16">正文</abbr></nav>
           <div style="margin-left: -90px;position: absolute;top: 30px;width: 75px;white-space: normal;color: #8C8C8C;"><span class="font12">上传图片限8M以内，像素600W以内</span></div>
          <div id="ueditor" type="text/plain"></div>
        </div>
        <div class="showUEplace" :style="{'display': CNmode ? 'none' : 'block'}">
          <nav class="m_l_10 m_b_5"><i class="VioletDot"></i><abbr class="font16">content</abbr></nav>
          <div id="ueditor2" type="text/plain"></div>
        </div>
      </div>
      <div v-show="!isTwoNext">

<ul class="allUL">
    <li style="display: flex;align-items: center;">
      <span style="font-size:16px;width: 80px;"><i class="colorRed m_r_5">*</i>请选择</span>
      <div><input v-model="tagType"  type="radio" value="recentlyTag" class="allRadio" id="recentlyTag" name="recentlyTag" />
      <label for="recentlyTag"></label><abbr>最近使用标签</abbr>
      <input v-model="tagType" type="radio" value="aiTag" class="allRadio" id="aiTag" name="aiTag" />
      <label for="aiTag"></label><abbr>AI推荐标签</abbr>
      </div>
    </li>
    </ul>

</div>
      <div class="m_t_10 t_c" v-show="isTwoNext">
        <button v-if="previewContentId !== 0" @click="coverShow = true" class="redButtonTwo">
          <i style="font-size: 10px!important;margin-right: 5px" class="icon iconfont iconyanjing"></i>预览
        </button>
        <!--        <button class="redButtonTwo" @click="SendList()" v-if="this.previewContentId !== 0 && fromType !== 'MaterialLibrary'">发送测试消息</button>-->
        <!--          <button class="redButtonTwo"  @click="preview">预览</button>-->
        <button v-if="fromType === 'MaterialLibrary'" class="redButtonTwo" @click="MaterialSave">保存至草稿箱</button>
        <button v-else @click="saveDraft(1)" class="redButtonTwo">保存</button>
        <!-- <button class="cancelButtonTwo"  @click="allReturn">返回</button> -->
        <button v-if="!postModel.willpublish" class="cancelButtonTwo" @click="saveDraft(2)">提交</button>
        <button v-else class="cancelButtonTwo" @click="saveDraft(1)">提交</button>
        
      </div>

      <div class="m_t_10 t_c" v-show="!isTwoNext">
        <button class="redButtonTwo" @click="nextTo">下一步</button>
        <button
            class="cancelButtonTwo"
            @click="allReturn"
          >返回</button>
      </div>
    </div>
    <div hidden><div id="handleContentHtml"></div></div>
    <contentPreview :object="postModel" :contentId="previewContentId" v-model="coverShow" :allNewKind="fromType"></contentPreview>
    <userPicker :title="'发送测试消息'" v-on:choosedConfirm="confirUserPicker($event)" v-model="userPickerModel" :pickerModel="'wechatUser'"></userPicker>
    <!--内容列表-新建内容-->
    <model v-if="showMaterial" :buttonType="0" :title="'新建草稿'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div class="t_c" style="margin-top: 30px;margin-bottom: 20px;height: 200px">
        <span><i class="colorRed m_r_5">*</i><abbr>内容类别：</abbr></span>
        <abbr style="width: 150px" class="d_i">
          <allSelect :chooseData="allcontent2" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'typeName'" :showValue="'{{typeName}}'" v-model="addnewContentType">
          </allSelect>
        </abbr>
      </div>
    </model>
    <model v-if="surModel" :buttonType="0" :title="'选择调研'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirmSurChoose()">
      <div>
        <surveryList @getSurId="getSur"></surveryList>
      </div>
    </model>
    <model v-if="showScorllFlag" :buttonType="0" :title="'新增滚动轮播图'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirmAddScorll()">
      <div class="newUserData">
        <div :key="index" v-for="(item, index) in bindScorllImg">
          <div>
            <i class="colorRed">*</i> <span>上传图片：</span><abbr>
              <input @change="changeImgFile($event, index)" type="file" :id="'inFile' + index" class="coverFile" accept="image/*"/>
              <label style="width: 500px;height: 250px" :for="'inFile' + index">
                <div v-if="item.imgId !== 0">
                  <img :src="item.imgUrl" width="500" height="250" style="border-radius: 8px"/>
                </div>
                <div v-else style="margin-top: 20px">
                  <i class="icon iconfont iconshangchuan1 colorDH" style="font-size: 50px;display:block;margin-top: 90px"></i>
                  <p class="m_t_10 colorGray">点击上传图片</p>
                </div>
              </label>
            </abbr>
            <abbr style="vertical-align: bottom" class="d_i colorGray">
              <p>图片比例推荐1000*500</p>
              <p>图片小于2M</p>
            </abbr>
          </div>
          <div>
            <span>外链Url：</span>
            <abbr>
              <input style="margin-left: 8px;width: 490px" class="allInput" type="text" v-model="item.url"/>
            </abbr>
          </div>
          <div class="addreduce">
            <i v-if="bindScorllImg.length > 1" @click="reduceBanner(index)" class="icon iconfont iconzhengfangxingjian colorCH m_r_10"></i>
            <i @click="addnewBanner" class="icon iconfont iconzhengfangxingjia colorCH"></i>
          </div>
        </div>
      </div>
    </model>
    <model v-if="showClop" :buttonType="0" :title="'上传封面'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="clopConfirm()">
      <div style="height: 500px">
        <vueCropper
          ref="cropper2"
          :img="example2.img "
          :outputSize="example2.size"
          :outputType="example2.outputType"
          :info="example2.info"
          :canScale="example2.canScale"
          :autoCrop="example2.autoCrop"
          :centerBox="example2.centerBox"
          :autoCropWidth="example2.autoCropWidth"
          :autoCropHeight="example2.autoCropHeight"
          :fixed="example2.fixed"
          :fixedNumber="example2.fixedNumber"
          :enlarge="4"
        ></vueCropper>
      </div>
    </model>
    <!-- 选择标签 -->
    <model v-if="showTagModal" :buttonType="0" :title="'选择标签'" :minWidth="'900px'" v-on:on-cancel="cancelTagModel()" v-on:on-confirm="confirmTagModal()">
      <div style="padding: 10px;width: auto;">
        <!-- 已选择的标签 -->
        <div class="myTag-box">
          <span class="title">已选标签：</span>
          <template v-for="(item, index) in selectedTags" >
            <span class="selected-tags" :style="index == 0 ? 'margin-left: 0;' : ''" :key="index">
              <span style="margin-right: 10px;">{{item.name}}</span>
              <i class="icon iconfont iconguanbi2" style="color: #fff;" @click="cancelSelectedHanlder(item, index)"></i>
            </span>
          </template>
        </div>
        <!-- 所有标签 -->
        <div class="allTag-box">
          <div class="topTag">
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 1, 'tags-topTag': true}" @click="tabNumChange(1)">科室</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 2, 'tags-topTag': true}" @click="tabNumChange(2)">领域</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 3, 'tags-topTag': true}" @click="tabNumChange(3)">适应症</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 4, 'tags-topTag': true}" @click="tabNumChange(4)">文章形式</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 5, 'tags-topTag': true}" @click="tabNumChange(5)">内容方向</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 6, 'tags-topTag': true}" @click="tabNumChange(6)">自定义标签</span>
          </div>
          <div style="position:relative" class="sonTag" :style="tagModalData.tabNum == 1 ? '' : 'border-top-left-radius: 10px;'">
            <div v-if="tagModalData.tabNum != 6 || (tagModalData.tabNum ==6 && isShowParent)" class="searchTag">
              <input class="allInput" type="text" v-model="tagModalData.tagName" style="backgrond-color: #fff;width: 200px;border-radius: 30px;box-sizing: border-box;padding-right: 30px;">
              <i class="icon iconfont iconsousuo" style="color: #ee1100;margin-left: -33px;font-size: 20px!important;"></i>
              <!-- <span style="margin-left:20px;font-size: 14px;color: #ee1100;" v-show="tagModalData.tabNum ==6 && isShowParent">请选择父标签</span> -->
              <button class="cancelButtonTwo" style="margin-left: 20px;" v-show="tagModalData.tabNum == 1" @click="setALLdepartment">所有科室</button>
              <span v-show="tagModalData.tabNum === 6" style="color: red;font-size: 14px;margin-left: 20px;">前三个自定义标签展示手机端</span>
            </div>
            <div class="tags">
              <!-- 科室 -->
              <div v-if="tagModalData.tabNum == 1">
                <template v-for="item in departmentList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseDeparment(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 领域 -->
              <div v-if="tagModalData.tabNum == 2">
                <template v-for="item in fieldsList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseField(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 适应症 -->
              <div v-if="tagModalData.tabNum == 3">
                <template v-for="item in indicationsList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseIndicaton(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 文章形式 -->
              <div v-if="tagModalData.tabNum == 4">
                <template v-for="item in articleFormList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseArticleForm(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 内容方向 -->
              <div v-if="tagModalData.tabNum == 5">
                <template v-for="item in contentDirectionList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseContentDirection(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 自定义 -->
              <div v-if="tagModalData.tabNum == 6">
                
                <template v-for="item in customTagShow">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': (!item.isParent && item.checked)||(item.isParent && item.customTagChild.some(child => child.checked === true))}"
                      :key="item.id"
                      @click="chooseCustomeTag(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
                <br>
                <button v-if="!isShowParent" style="position:absolute;bottom:10px;right:10px" class="cancelButtonTwo" @click="showParent">返回</button>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
    </model>

<!-- 选择AI标签 -->
<model v-if="showTagModalAI" :buttonType="0" :title="'选择标签'" :minWidth="'900px'" v-on:on-cancel="cancelTagModelAI()" v-on:on-confirm="confirmTagModal()">
      <div style="padding: 10px;width: auto;">
        <!-- 已选择的标签 -->
        <div class="myTag-box" style="display: flex;flex-direction: column;justify-content: space-between;">
          <div>
            <span class="title" style="margin-left: 10px;"> AI推荐标签(已审核)：</span>
          <template v-for="(item, index) in selectedTags" >
            <span :class="item.isAI?'selected-AItags':'selected-tags'" :style="index == 0 ? 'margin-left: 45px;' : ''" :key="index">
              <span style="margin-right: 10px;">{{item.name}}</span>
              <i class="icon iconfont iconguanbi2" :style="item.isAI?'color:red':'color: #fff'" @click="cancelSelectedHanlder(item, index)"></i>
            </span>
          </template>
          </div>

          <div>
            <p style="color: #ccc;text-indent: 10px;margin: 0;padding: 0;"> 注:AI已从审核标签中选择标签进行推荐，标签为白色底色，如认为不正确，可以删除并从下方列表中选择新的标签，修改后的标签为红色底色</p>
          </div>
        </div>

        <div class="myTag-box" style="margin-top: 10px;display: flex;flex-direction: column;justify-content: space-between;" >
          <div>
            <span class="title" style="margin-left: 10px;">AI推荐标签(未审核)：</span>
          <template v-for="(item, index) in unauditedAItag" >
            <span class="selected-tags" :style="index == 0 ? 'margin-left: 50px;backgroundColor:#fff;color:red' : 'backgroundColor:#fff;color:red'" :key="index">
              <span style="margin-right: 10px;">{{item.name}}</span>
              <i class="icon iconfont iconguanbi2" :style="item.isAI?'color:red':'color: #fff'" @click="delUnAuditedTag(item, index)"></i>
            </span>
          </template>
          </div>

          <div>
            <p style="color: #ccc;text-indent: 10px;margin: 0;padding: 0;">注:AI总结的新标签为白色底色，仅可查看</p>
          </div>
          
        </div>

        <!-- 所有标签 -->
        <div class="allTag-box">
          <div class="topTag">
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 1, 'tags-topTag': true}" @click="tabNumChange(1)">科室</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 2, 'tags-topTag': true}" @click="tabNumChange(2)">领域</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 3, 'tags-topTag': true}" @click="tabNumChange(3)">适应症</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 4, 'tags-topTag': true}" @click="tabNumChange(4)">文章形式</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 5, 'tags-topTag': true}" @click="tabNumChange(5)">内容方向</span>
            <span :class="{'activedTags-topTag': tagModalData.tabNum == 6, 'tags-topTag': true}" @click="tabNumChange(6)">自定义标签</span>
          </div>
          <div style="position:relative" class="sonTag" :style="tagModalData.tabNum == 1 ? '' : 'border-top-left-radius: 10px;'">
            <div v-if="tagModalData.tabNum != 6 || (tagModalData.tabNum ==6 && isShowParent)" class="searchTag">
              <input class="allInput" type="text" v-model="tagModalData.tagName" style="backgrond-color: #fff;width: 200px;border-radius: 30px;box-sizing: border-box;padding-right: 30px;">
              <i class="icon iconfont iconsousuo" style="color: #ee1100;margin-left: -33px;font-size: 20px!important;"></i>
              <!-- <span style="margin-left:20px;font-size: 14px;color: #ee1100;" v-show="tagModalData.tabNum ==6 && isShowParent">请选择父标签</span> -->
              <button class="cancelButtonTwo" style="margin-left: 20px;" v-show="tagModalData.tabNum == 1" @click="setALLdepartment">所有科室</button>
              <span v-show="tagModalData.tabNum === 6" style="color: red;font-size: 14px;margin-left: 20px;">前三个自定义标签展示手机端</span>
            </div>
            <div class="tags">
              <!-- 科室 -->
              <div v-if="tagModalData.tabNum == 1">
                <template v-for="item in departmentList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseDeparment(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 领域 -->
              <div v-if="tagModalData.tabNum == 2">
                <template v-for="item in fieldsList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseField(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 适应症 -->
              <div v-if="tagModalData.tabNum == 3">
                <template v-for="item in indicationsList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseIndicaton(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 文章形式 -->
              <div v-if="tagModalData.tabNum == 4">
                <template v-for="item in articleFormList">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseArticleForm(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 内容方向 -->
              <div v-if="tagModalData.tabNum == 5">
                <template v-for="item in contentDirectionList">

                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': item.checked}"
                      :key="item.id"
                      @click="chooseContentDirection(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
              </div>
              <!-- 自定义 -->
              <div v-if="tagModalData.tabNum == 6">
               
                <template v-for="item in customTagShow">
                  <el-tooltip :key="item.id" :open-delay="800" popper-class="el-popper1" :content="item.name" placement="bottom" effect="light">
                    <span
                      :class="{'plain-tags': true, 'checked-tags': (!item.isParent && item.checked)||(item.isParent && item.customTagChild.some(child => child.checked === true))}"
                      :key="item.id"
                      @click="chooseCustomeTag(item)">
                      {{item.name.length > 10 ? item.name.substring(0,10)+"..." : item.name}}
                    </span>
                  </el-tooltip>
                </template>
                <br>
                <button v-if="!isShowParent" style="position:absolute;bottom:10px;right:10px" class="cancelButtonTwo" @click="showParent">返回</button>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
    </model>


    <!-- 选择文章 -->
    <model v-if="showArticalModal" :buttonType="0" :title="'选择文章'" :minWidth="'1000px'" v-on:on-cancel="cancelArticalModal()" v-on:on-confirm="confirmArticalModal()">
      <div class="newSearch d_i m_t_10 m_b_10">
        <p class="d_i m_l_10">
          <input v-model="articalModal.creator" class="allInput" type="text" placeholder="创建人">
        </p>
        <p class="d_i m_l_10">
          <input v-model="articalModal.tags" class="allInput" type="text" placeholder="标签">
        </p>
        <p class="d_i m_l_10">
          <input v-model="articalModal.title" class="allInput" type="text" placeholder="文章名称">
        </p>
        <p class="d_i m_l_10">
          <abbr class="d_i">
            <allSelect :chooseData="searchCate" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'name'" :showValue="'{{productName}} | {{name}}'" v-model="articalModal.categoryId">
            </allSelect>
          </abbr>
        </p>
      </div>
      <div class="d_i m_l_10">
        <button class="redButton" @click="getMyArticalList(1)">
          <i class="icon iconfont iconsousuo"></i>
          <span>搜索</span>
        </button>
      </div>
      <div style="max-height: 400px;overflow: auto">
        <table cellspacing="0" class="allTable alltableHui">
          <thead>
          <tr style="background-color: #FBFBFB;color: #797979">
            <th width="10%"></th>
            <th>ID</th>
            <th>文章名称</th>
            <th class="t_c">标签</th>
            <th class="t_c">分类</th>
            <th class="t_c">创建人</th>
          </tr>
          </thead>
          <tbody>
          <tr @click="chooseArtical(item)" :class="selectArticalId === item.id ? 'choosed' : ''" :key="index" v-for="(item, index) in myArticalList">
            <td>
              <!--<input type="radio" class="allRadio" id="radio3" name="radioMdole"/>-->
              <!--<label for="radio3"></label>-->
            </td>
            <td>{{item.id}}</td>
            <td class="NoWrap" width="20%" style="max-width: 200px">{{item.title}}</td>
            <td class="t_c NoWrap" width="20%" style="max-width: 200px" >{{item.tags}}</td>
            <td class="t_c">{{item.categoryName}}</td>
            <td class="t_c">{{item.createName}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :size="5" v-on:on-getList="getMyArticalList($event)" :totalCount="articaltotalCount" :totalPage="articalTotalPage" :page="articalPageIndex" :explain="0"></page>
    </model>


  </div>
</template>

<script>
import avatar from '@/assets/loading.gif'
import '../../../../static/utf8-jsp/ueditor.config'
import '../../../../static/utf8-jsp/ueditor.all'
import '../../../../static/utf8-jsp/lang/zh-cn/zh-cn'
import '../../../../static/utf8-jsp/ueditor.parse.js'
import { VueCropper } from 'vue-cropper'
import surveryList from '../surveryManager/chooseSurveryList'
import xss from 'xss'
import contentPreview from '../../myComponents/contentPreview'
import Vue from 'vue';
import {Tooltip} from 'element-ui';
import { Loading } from 'element-ui';
// import { Button } from 'element-ui';
Vue.use(Tooltip);
// Vue.use(Button);
let scorllData = []
let setIntervalImg
export default {
  name: 'editContList',
  data () {
    return {
      isSort:false,
      yshid:[],
      delAItag:[],
      orginAllTagList:[],
      detailData:null,
      isShowApro:true,
      isClickToNext:false,
      isTwoNext:false,
      tagType:'aiTag',
      aiTag:null,
      unauditedAItag:[],
      aiTagList:[],
      otherAItagList:[],
      isSynCOCE: false,
      isSynCDMA: false,
      brandList: [
      ],
      testList: [],
      showClop: false,
      bindScorllImg: [
        {
          imgUrl: '',
          imgId: 0,
          url: ''
        }
      ],
      example2: {
        // img的路径自行修改
        img: '',
        info: true,
        size: 0.5,
        outputType: 'png',
        canScale: true,
        autoCrop: true,
        centerBox: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 800,
        autoCropHeight: 344,
        fixed: true,
        // 真实的输出宽高
        infoTrue: true,
        fixedNumber: [100, 43]
      },
      showScorllFlag: false,
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      addnewContentType: '',
      showMaterial: false,
      ue: '',
      ueEn: '',
      previewContentId: parseInt(this.$route.query.id),
      coverShow: false,
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      CNmode: true,
      fromType: this.$route.query.fromType,
      selectContentName: this.$route.query.selectContentName,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      page: 1,
      postModel: {
        ContentTypeId: parseInt(this.$route.query.selectContentType),
        Id: parseInt(this.$route.query.id),
        TitleCN: '',
        CoverCN: 0,
        sourceUrl: '',
        need_open_comment: false,
        isshowurl: false,
        iscanfoward: true,
        willpublish:false,
        willpublishtime:'',
        // willpublishtime:this.$commonJs.returnNowDate('YYMMDD'),
        isshowAuthor: false,
        isAudio: false, // 控制播放开关
        audioType: 'F',
        tags: '',
        researchId: 0,
        SummaryCN: '',
        ContentCN: '',
        TitleEN: '',
        CoverEN: 0,
        SummaryEN: '',
        ContentEN: '',
        CreateTime: '',
        materialScope: '',
        audioContent: '',
        author: '', // 作者
        articleType: 'F', // 全图文 F全图文，H半图文
        auditNo: '', // 审核编号
        declared: '', // 声明
        articleTagsId: [], // 标签id
        sourceArticleTitle: '', // 选择的文章title
        sourceArticleId: 0, // 选择的文章id
        activeTime: '',
        inActiveTime: '',
        brandCode: '',
        synC_OCE: 0,
        synC_DMA: 0,
        firstSubmitTime: 0,
        isPromotion: "",
        countyInfo:"ArticleCollection",
        topicId:null
      },
      countyInfoList:[],
      chooseUserList: [],
      // 话题下拉
      topciList:[],
      userPickerModel: false,
      newNumId: '',
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')) || {},
      postData: {
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      showPlayRadio: false,
      showTagModal: false,
      showTagModalAI:false,
      tagModalData: {
        tagName: '',
        tabNum: 1
      },
      fieldsList: [], // 领域
      indicationsList: [], // 适应症
      departmentList: [], // 科室
      articleFormList: [], //文章形式
      contentDirectionList: [], //内容方向
      selectedTags: [], // 已选的标签
      isadmin: JSON.parse(window.localStorage.getItem('isAdmin')), // 管理员
      customTagList: [], // 自定义标签(父)
      customTagShow: [],
      isShowParent:true,
      allTagList: [], // 所有标签，包括科室、领域、适应症、自定义
      showArticalModal: false, // 选择文章模态框
      articalModal: {
        status: 2,
        title: '',
        creator: '',
        categoryId: '',
        tags: '',
        articleType: 'F', // F-全图文, H-半图文
      },
      searchCate: [{
        id: '',
        name: '全部',
        productName: '全部'
      }],
      myArticalList: [], // 文章列表
      articalPageIndex: 1,
      articaltotalCount: 0,
      articalTotalPage: 0,
      selectArticalId: 0,
      surModel: false,
      surName: '',
      surId: '',
      // 是否全选
      isTrueOrFalse:false,
      showoverlay:false
    }
  },
  created () {
    // 选择文章弹窗 分类数据
    this.searchCate = this.searchCate.concat(this.allcontent2)
    console.log(this.postModel.Id)
    console.log(this.postModel.Id !== 0)
    if (this.postModel.Id !== 0) {
      this.getDetail()
    }
    // if (this.fromType === 'MaterialLibrary') {
    //   this.getconTypeList(1)
    // }

    // 获取所有标签
    this.getTagList()
    this.getCountyInfoList()
    this.getTopicList()
  },
  mounted () {
    setTimeout(p => {
      // eslint-disable-next-line no-undef
      this.ue = UE.getEditor('ueditor', {
        BaseUrl: '',
        UEDITOR_HOME_URL: 'static/utf8-jsp/',
        toolbars: [
          ['fullscreen', 'source', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'fontfamily', 'fontsize','paragraph','customstyle', '|', 'imagenone','imageleft','imageright','imagecenter',],
          ['indent','directionalityltr','directionalityrtl','rowspacingtop','rowspacingbottom','lineheight', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|','strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'pasteplain', '|', 'forecolor', 'touppercase', 'tolowercase', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', 'link','unlink', 'simpleupload', 'insertvideo']
        ]
      })
      // 'blockquote' insertimage,
      // eslint-disable-next-line no-undef
      this.ueEn = UE.getEditor('ueditor2', {
        BaseUrl: '',
        UEDITOR_HOME_URL: 'static/utf8-jsp/',
        toolbars: [
          ['fullscreen', 'source', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'fontfamily', 'fontsize', 'paragraph','customstyle', '|', 'imagenone','imageleft','imageright','imagecenter',],
          ['indent','directionalityltr','directionalityrtl','rowspacingtop','rowspacingbottom','lineheight','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|','strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'pasteplain', '|', 'forecolor', 'touppercase', 'tolowercase', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', 'link','unlink', 'simpleupload', 'insertvideo']
        ]
      })
      if (this.postModel.Id === 0) {
        setTimeout(p => {
          let dom = document.createElement('div')
          dom.id = 'addScorllButton'
          let html = '<div title="轮播图上传"><i class="icon iconfont iconlunbo"></i></div>'
          dom.innerHTML = html
          let dom2 = document.createElement('div')
          dom2.id = 'addScorllButton2'
          dom2.innerHTML = html
          console.log(document.querySelectorAll('.edui-toolbar'))
          // document.querySelectorAll('.edui-toolbar')[1].appendChild(dom)
          // document.querySelectorAll('.edui-toolbar')[3].appendChild(dom2)
          // document.getElementById('addScorllButton').onclick = p => {
          //   this.showScorllFlag = true
          //   this.bindScorllImg = [
          //     {
          //       imgUrl: '',
          //       imgId: 0,
          //       url: ''
          //     }
          //   ]
          // }
          // document.getElementById('addScorllButton2').onclick = p => {
          //   this.showScorllFlag = true
          //   this.bindScorllImg = [
          //     {
          //       imgUrl: '',
          //       imgId: 0,
          //       url: ''
          //     }
          //   ]
          // }
        }, 2000)
      }
    }, 10)
    this.getBrandList()
    this.getArticleStatement()
  },
  destroyed () {
    const domList = document.querySelectorAll('.showUEplace')
    for (let i = 0; i < domList.length; i++) {
      domList[i].style.display = 'none'
    }
    this.ue.destroy()
    this.ueEn.destroy()
  },
  methods: {
    getTopicList(){
      this.$axiox.post('/api/topic/GetAllTopics',{
        topicName:'',
        pageIndex:1,
        pageSize:99999999
      }).then(res => {
        console.log('topciList',res)
        this.topciList = res
      })
    },
    getCountyInfoList () {
      this.$axiox.get(`/api/Article/GetAggregateRotateSearchList`).then(res => {
        this.countyInfoList = res
      })
      
      // this.countyInfoList=[{id:'False',name:'文章集锦'},{id:"True",name:'县域专区'}]
    },
    changeSyncOCE(){
      this.isSynCOCE ? this.postModel.synC_OCE = 1 : this.postModel.synC_OCE = 0
      if(!this.isSynCOCE){
        this.postModel.synC_DMA = 0
      }
      this.$forceUpdate()
      console.log(this.postModel.synC_OCE)
    },
    changeSyncDMA(){
      this.isSynCDMA ? this.postModel.synC_DMA = 1 : this.postModel.synC_DMA = 0
      this.$forceUpdate()
    },
    getBrand(e){
      console.log(e)
      this.postModel.brandCode = e.brandCode
    },
    getMulBrand(e){
      this.postModel.brandCode = e
    },
    getArticleStatement(){
      this.$axiox.get('/api/AppSettings/GetAppSettingByKey?key=ArticleStatement').then( p => {
        console.log(p)
        !this.postModel.declared ? this.postModel.declared = p : ''
      } )
    },
    getBrandList(){
      this.$axiox.get('/api/Dict/Get/brands').then( p => {
        this.brandList = p || []
      } )
    },
    confirmSurChoose () {
      this.postModel.researchId = this.surId
      this.surModel = false
    },
    getSur (e) {
      this.surName = e.researchName
      this.surId = e.id
    },
    addSur () {
      this.surModel = true
    },
    delSur () {
      this.postModel.researchId = 0
      this.surName = ''
      this.surId = 0
    },
    changeRadio () {
      const data = this.postModel.isAudio
      if (data) {
        this.showPlayRadio = true
        this.postModel.audioType = 'F'
      } else {
        this.showPlayRadio = false
        this.postModel.audioType = null
      }
    },
    preview () {
    },
    submit () {
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    blobToFile (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    clopConfirm () {
      this.$refs.cropper2.getCropData((data) => {
        this.modelSrc = data
        this.model = false
        this.example2.img = this.modelSrc
        // console.log(this.example2.img)
        var blob = this.dataURLtoBlob(this.modelSrc)
        var file = this.blobToFile(blob, '裁剪后图片')
        console.log(file.property)
        if (file.size > 2048000) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '提示',
            content: '文件大小不允许大于2M',
            stayTime: 5
          })
          return
        }
        this.signalUpload(file)
      })
    },
    clopuploadImg (e, num) {
      // 上传图片
      this.example2.img = ''
      var file = e.target.files[0]
      const image = new Image()
      const thnes = this
      let isbreak = false
      image.onload = function() {
        
        if (this.width !== 900 || this.height !== 383) {
          thnes.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '图片尺寸必须是900*383',
          stayTime: 5
        })
        isbreak = true
        }else{
          thnes.signalUpload(file)
        }

      }

      if (file) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          image.src = e.target.result
        }
      }

      // if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '提示',
      //     content: '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
      //     stayTime: 5
      //   })
      //   // alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
      //   return false
      // }
      // this.showClop = true
      // this.$nextTick(p => {
      //   var reader = new FileReader()
      //   reader.onload = (e) => {
      //     let data
      //     data = e.target.result
      //     if (typeof e.target.result === 'object') {
      //       // 把Array Buffer转化为blob 如果是base64不需要
      //       data = window.URL.createObjectURL(new Blob([e.target.result]))
      //     } else {
      //       data = e.target.result
      //     }
      //     if (num === 1) {
      //       this.option.img = data
      //     } else if (num === 2) {
      //       this.example2.img = data
      //     }
      //   }
      //   reader.readAsArrayBuffer(file)
      // })
      // // 转化为base64
      // // reader.readAsDataURL(file)
      // // 转化为blobcs
      // this.signalUpload(file)
    },
    reduceBanner (index) {
      this.bindScorllImg.splice(index, 1)
    },
    addnewBanner () {
      let data = {
        imgUrl: '',
        imgId: 0,
        url: ''
      }
      this.bindScorllImg.push(data)
    },
    async changeImgFile (e, index) {
      let fileImg = e.target.files[0]
      this.bindScorllImg[index].imgId = await this.$commonJs.uploadFile(fileImg)
      this.bindScorllImg[index].imgUrl = this.baseUrl + '/api/Article/file/' + this.bindScorllImg[index].imgId
      // this.allspeakerRequestList.avatar = baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + this.avatarId
      e.target.value = ''
    },
    confirmAddScorll () {
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        if (this.bindScorllImg[i].imgUrl === '') {
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '有图片没上传,请检查！',
            stayTime: 5
          })
          return
        }
        if (this.bindScorllImg[i].url && this.bindScorllImg[i].url !== '' && this.bindScorllImg[i].url.indexOf('http') !== 0) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '图片链接必须以http或者https开头',
            stayTime: 5
          })
          return
        }
      }
      let html = '<section class="myScorllImgPlace">'
      html += '<section class="dotPlace">'
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        if (i === 0) {
          html += '<b class="dot active"></b>'
        } else {
          html += '<b class="dot"></b>'
        }
      }
      html += '</section>'
      html += '<section style="left: 0px" class="showPlace">'
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        html += '<section>'
        if (this.bindScorllImg[i].url !== '') {
          html += '<a target="_blank" href="' + this.bindScorllImg[i].url + '">'
        } else {
          html += '<a>'
        }
        html += '<img src="' + this.bindScorllImg[i].imgUrl + '" alt="">'
        html += '</a>'
        html += '</section>'
      }
      html += '</section>'
      html += '</section>'
      if (this.CNmode) {
        // this.ue.body.innerHTML = this.ue.body.innerHTML + html
        this.ue.focus()
        this.ue.execCommand('inserthtml', html)
      } else {
        // this.ueEn.body.innerHTML = this.ueEn.body.innerHTML + html
        this.ueEn.focus()
        this.ueEn.execCommand('inserthtml', html)
      }
      this.showScorllFlag = false
    },
    // getconTypeList (pageIndex) {
    //   this.postData.pageIndex = pageIndex
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent2 = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    // getconTypeList () {
    //   this.$axiox.get('/api/contentType/fromuser/' + JSON.parse(this.userInfo.id)).then(msg => {
    //     let editorTypes = JSON.parse(JSON.stringify(msg.result.editorTypes))
    //     let ownerTypes = JSON.parse(JSON.stringify(msg.result.ownerTypes))
    //     this.allcontent2 = this.$commonJs.distinct(editorTypes, ownerTypes)
    //   })
    // },
    copyShaneUrl (shareLink) {
      // console.log('shareLink', shareLink)
      var input = document.createElement('input') // 直接构建input
      input.value = shareLink // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
    },
    getDetail () {
      let url = ''
      if (this.fromType === 'MaterialLibrary') {
        url = '/api/content/material?materialId=' + this.previewContentId
      } else {
        url = '/api/Article/' + this.postModel.Id
      }
      this.$axiox.get(url).then(p => {
        console.log('获取数据', p)
        if (p.unionContent) {
          this.$commonJs.copyComfirm({
            content: '该图文内容为微网站同步的文章，点击【复制】按钮复制正文内容，即可粘贴至正文编辑框。',
            successFun: msg => {
              console.log(p.unionContent, 'p.unionContent')
              this.copyShaneUrl(p.unionContent)
              // if (window.location.href.indexOf('wechatweb.takeda.com.cn') > -1 || window.location.href.indexOf('wechatweb-dev.takeda.com.cn') > -1) {
              //   // 生产 测试环境
              //   p.unionContent = p.unionContent.replace('http://', 'https://')
              //   p.unionContent = p.unionContent.replace('HTTP://', 'HTTPS://')
              //   console.log(p.unionContent,'生产 测试环境')
              //   this.copyShaneUrl(p.unionContent)
              // } else {
              //   // 开发环境
              //   this.copyShaneUrl(p.unionContent)
              //   console.log(p.unionContent, '开发环境')
              // }
            },
            errorFun: msg => {
            }
          })
        }
        this.detailData = p
        this.postModel = {
          ContentTypeId: parseInt(p.categoryId),
          ContentTypeName: p.categoryName,
          Id: parseInt(p.id),
          TitleCN: p.title,
          sourceUrl: p.sourceUrl,
          need_open_comment: p.need_open_comment,
          isshowurl: p.isshowurl,
          iscanfoward: p.iscanfoward,
          willpublish:p.willpublish,
          willpublishtime:p.willpublishtime?  this.$commonJs.returnDate(p.willpublishtime, 'YYMMDDHHMM') : '',
          isshowAuthor: p.isshowAuthor,
          researchId: p.researchId,
          CoverCN: p.fileID,
          SummaryCN: p.summary==" "?"":p.summary,
          ContentCN: p.content.replace(/&lt;iframe/g, '<iframe').replace(/&gt;&lt;\/iframe&gt;/g, '></iframe>').replace(/&lt;source/g, '<source').replace(/\/&gt;/g, '/>'),
          TitleEN: '',
          tags: p.tags,
          CoverEN: '',
          SummaryEN: '',
          ContentEN: '',
          materialScope: '',
          CreateTime: p.creationTime,
          LastModifyTime: p.lastModificationTime,
          author: p.author,
          articleType: p.articleType, // 全图文 F全图文，H半图文
          auditNo: p.auditNo, // 审核编号
          declared: p.declared, // 声明
          articleTagsId: p.articleTagsId,
          sourceArticleTitle: p.sourceArticleTitle,
          sourceArticleId: p.sourceArticleId,
          // 音频
          isAudio: p.isAudio,
          audioType: p.audioType,
          audioContent: p.audioContent,
          aiTagRequestId:p.aiTagRequestId,  
          activeTime: p.activeTime ?  this.$commonJs.returnDate(p.activeTime, 'YYMMDD') : this.$commonJs.returnNowDate('YYMMDD'),
          inActiveTime: p.inActiveTime ? this.$commonJs.returnDate(p.inActiveTime, 'YYMMDD') : '',
          brandCode: p.brandCode,
          synC_OCE: p.synC_OCE || 0,
          synC_DMA: p.synC_DMA || 0,
          firstSubmitTime: p.firstSubmitTime?p.firstSubmitTime:0,
          isPromotion:p.isPromotion,
          //isPromotion: (p.isPromotion == "True" || p.isPromotion == "False") ? p.isPromotion : "False"
          countyInfo:p.countyInfo,
          topicId:p.topicId
        }
        this.isSynCOCE = this.postModel.synC_OCE === 1
        this.isSynCDMA = this.postModel.synC_DMA === 1
        this.getArticleStatement()
        if (p.researchId) {
          this.$axiox.get('/api/Research/detail/' + p.researchId).then(msg => {
            this.surName = msg.researchName
            this.surId = msg.id
          })
        }
        p.isAudio ? this.showPlayRadio = true : this.showPlayRadio = false
        console.log(this.postModel)
        let time = setInterval(p => {
          if (this.ue.body && this.ueEn.body) {
            this.ue.body.innerHTML = this.postModel.ContentCN
            this.ueEn.body.innerHTML = this.postModel.ContentEN
            let dom = document.createElement('div')
            dom.id = 'addScorllButton'
            let html = '<div title="轮播图上传"><i class="icon iconfont iconlunbo"></i></div>'
            dom.innerHTML = html
            let dom2 = document.createElement('div')
            dom2.id = 'addScorllButton2'
            dom2.innerHTML = html
            clearInterval(time)
          }
        }, 100)
        console.log(this.postModel)
      })
    },
    async signalUpload (e) {
      // let fileImg = e.target.files[0]
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.postModel.CoverCN = await this.$commonJs.uploadFile(fileImg)
        console.log(this.postModel.CoverCN)
        this.postModel.CoverEN = this.postModel.CoverCN
        // this.allspeakerRequestList.avatar = baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + this.avatarId
        // e.target.value = ''
        document.getElementById('inFile').value = ''
        this.showClop = false
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    changeType (type) {
      this.CNmode = type
    },
    MaterialSave () {
      this.showMaterial = true
      this.addnewContentType = ''
    },
    confirModel () {
      if (this.addnewContentType === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择内容类别',
          stayTime: 5
        })
        return
      }
      this.postModel.ContentCN = this.ue.getContent()
      this.postModel.ContentEN = this.ueEn.getContent()
      let data = JSON.parse(JSON.stringify(this.postModel))
      data.ContentTypeId = this.addnewContentType
      data.Id = 0
      if ((this.postModel.ContentCN !== '' && this.postModel.TitleCN === '') || (this.postModel.ContentCN === '' && this.postModel.TitleCN !== '')) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
      if ((this.postModel.ContentEN !== '' && this.postModel.TitleEN === '') || (this.postModel.ContentEN === '' && this.postModel.TitleEN !== '')) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
      if (!this.postModel.tags){
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标签的完整性',
          stayTime: 5
        })
      }
      if(this.postModel.synC_OCE === 1 && !this.postModel.brandCode) {
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
      }
      this.$axiox.post('/api/Article/Add', data).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.showMaterial = false
        this.$router.go(-1)
      })
    },
    cancelModel () {
      this.showModel = false
      this.showMaterial = false
      this.showScorllFlag = false
      this.surModel = false
      this.showClop = false
      this.surName = ''
      this.surId = ''
      document.getElementById('inFile').value = ''
    },
    // 返回上一页
    allReturn () {
      this.$commonJs.doubleComfirm({
        content: '确定要跳转吗？如果您有未保存的内容，可能会丢失哦。',
        successFun: msg => {
          this.$router.go(-1)
        },
        errorFun: msg => {
        }
      })
    },
    getTime () {
      let date1 = new Date()
      let year = date1.getFullYear()
      let month = date1.getMonth() + 1
      let day = date1.getDate()
      return year + '-' + month + '-' + day
    },
    scrollToTop(){
      const bodyright = document.getElementById('bodyright');
      console.log(bodyright.scrollTo)
      bodyright.scrollTo({
        top:0,
        behavior: 'smooth' // 平滑滚动
      })

    },
    saveDraft (status) {
      
      this.postModel.ContentCN = this.ue.getContent()
      this.postModel.CreateTime = this.getTime()
      this.postModel.LastModifyTime = this.getTime()
      this.postModel.ContentEN = this.ueEn.getContent()
      
      if(this.postModel.synC_OCE === 1 && !this.postModel.brandCode) {
        this.scrollToTop()
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
      }
      if(!this.postModel.activeTime || !this.postModel.inActiveTime) {
        this.scrollToTop()
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
      }
      if (this.postModel.articleType == 'F') {
        // 全图文
        if ((this.postModel.ContentCN === '' && this.postModel.TitleCN === '' && this.postModel.ContentEN === '' && this.postModel.TitleEN === '')
        || this.postModel.auditNo === '' || this.postModel.declared === '') {
          this.scrollToTop()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
      } else if (this.postModel.articleType == 'H') {
        // 半图文
        if (this.postModel.ContentCN === '' && this.postModel.TitleCN === '' && this.postModel.ContentEN === '' && this.postModel.TitleEN === ''|| this.postModel.auditNo === '') {
          this.scrollToTop()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
      } else if (this.postModel.articleType == 'FH') {
        // 半图文
        if (this.postModel.ContentCN === '' && this.postModel.TitleCN === '' && this.postModel.ContentEN === '' && this.postModel.TitleEN === ''|| this.postModel.auditNo === '' || this.postModel.declared === '') {
          this.scrollToTop()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
      }

      console.log("this.postModel.isPromotion",this.postModel.isPromotion)
      if(this.postModel.synC_OCE === 1){
        if(!(this.postModel.isPromotion =="True" || this.postModel.isPromotion == "False")){
          this.scrollToTop()
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请选择Promotion材料或Non-promotion材料',
            stayTime: 5
          })
          return 
        }
      }
      
      
      if ((this.postModel.ContentCN !== '' && this.postModel.TitleCN === '') || (this.postModel.ContentCN === '' && this.postModel.TitleCN !== '')) {
        this.scrollToTop()
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
      if ((this.postModel.ContentEN !== '' && this.postModel.TitleEN === '') || (this.postModel.ContentEN === '' && this.postModel.TitleEN !== '')) {
        this.scrollToTop()
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
       if (status == 2 && !parseInt(this.postModel.CoverCN)) {
        this.scrollToTop()
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '封面图片未上传!',
          stayTime: 5
        })
        return
      }
      //测试时可以关闭debugger
      if (status == 1 && !parseInt(this.postModel.CoverCN)&& this.postModel.willpublish) {
        this.scrollToTop()
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '定时发布必须上传封面!',
          stayTime: 5
        })
        return
      }
      if (!this.postModel.tags){
        this.scrollToTop()
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标签的完整性',
          stayTime: 5
        })
      }
      if(this.postModel.synC_OCE === 1 && !this.postModel.brandCode) {
        this.scrollToTop()
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
      }
      if(this.postModel.willpublish && this.postModel.willpublishtime==''){
        this.scrollToTop()
         this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择发布时间',
          stayTime: 5
        })
        return
      }
      if (this.postModel.ContentCN.indexOf('tencentTweets') >= 0) {
        this.postModel.ContentCN = this.$commonJs.returnToObtainDom(this.postModel.ContentCN, 'tencentTweets')
      }
      let html = '<p>'
      if (this.postModel.ContentCN.indexOf('tencentTweets') < 0) {
        html += `<section id="tencentTweets" style="margin-bottom: 100px;margin-top: 10px">`
        if (this.postModel.auditNo !== '') {
          //前端显示时隐藏审核编号及批准日期
          // html += `<section style="margin-bottom: 10px;color:rgb(137,137,137);white-space: normal;word-break: break-all">
          //             <span>审核编号：</span>
          //             <span>${this.postModel.auditNo}</span>
          //           </section>`
        }
        if (this.postModel.activeTime) {
          //前端显示时隐藏审核编号及批准日期
          // html += `<section style="margin-bottom: 10px;color:rgb(137,137,137);white-space: normal;word-break: break-all">
          //     <span>批准日期：</span>
          //     <span>${this.$commonJs.returnDate(this.postModel.activeTime, 'YYMM')}</span>
          //   </section>
          //   `
        }
        if (this.postModel.declared !== '') {
          html += `<section style="margin-bottom: 10px;color:rgb(137,137,137);white-space: normal;word-break: break-all">
                      <span>声明：</span>
                      <span>${this.postModel.declared}</span>
                    </section>
                  </section>
                `
        }

      }
      html += '</p>'
      document.getElementById('handleContentHtml').innerHTML = this.postModel.ContentCN + html
      let domList = document.getElementById('handleContentHtml').querySelectorAll('p')
      for (let i = 0; i < domList.length; i++) {
        domList[i].style.minHeight = 'auto'
        if (domList[i].childNodes && domList[i].childNodes.length === 1 && domList[i].childNodes[0].localName === 'br') {
          domList[i].style.fontSize = 0
        }
      }
      this.postModel.ContentCN = document.getElementById('handleContentHtml').outerHTML.replace('id="handleContentHtml"', '')
      // this.postModel.ContentCN = xss(this.postModel.ContentCN)
      let unAuditedTag = []
      this.unauditedAItag.forEach(res=>{
        unAuditedTag.push(res.name)
      })
      let data = {
        title: this.postModel.TitleCN,
        summary: this.postModel.SummaryCN==""?" ":this.postModel.SummaryCN,
        content: '<html>' + this.postModel.ContentCN.replace(/"/g, "'") + '</html>',
        wxContent: '',
        sourceUrl: this.postModel.sourceUrl,
        need_open_comment: this.postModel.need_open_comment,
        isshowurl: this.postModel.isshowurl,
        iscanfoward: this.postModel.iscanfoward,
        willpublish:this.postModel.willpublish,
        willpublishtime:this.postModel.willpublishtime,
        isshowAuthor: this.postModel.isshowAuthor,
        researchId: this.postModel.researchId,
        status: status,
        tags: this.postModel.tags,
        categoryId: this.postModel.ContentTypeId || parseInt(this.$route.query.selectContentType) || '',
        categoryName: this.postModel.ContentTypeName || this.$route.query.selectContentName || '',

        fileID: parseInt(this.postModel.CoverCN),
        isAudio: this.postModel.isAudio,
        audioType: this.postModel.audioType,
        audioContent: this.postModel.audioContent,
        author: this.postModel.author,
        articleType: this.postModel.articleType, // 全图文 F全图文，H半图文
        auditNo: this.postModel.auditNo, // 审核编号
        declared: this.postModel.declared, // 声明
        articleTagsId: this.postModel.articleTagsId, // 标签id
        sourceArticleId: this.postModel.sourceArticleId, // 文章id
        
        activeTime: this.postModel.activeTime,
        inActiveTime: this.postModel.inActiveTime,
        brandCode: this.postModel.brandCode,
        synC_OCE: this.postModel.synC_OCE,
        synC_DMA: this.postModel.synC_DMA,
        isPromotion: this.postModel.isPromotion,
        countyInfo:this.postModel.countyInfo,
        topicId:this.postModel.topicId,
        aiTagRequestId:this.postModel.aiTagRequestId,
        unAuditedTag:unAuditedTag,
        unAuditedDelTag:this.delAItag,
        isSort:this.isSort
      }
      
      if(this.aiTag&&this.aiTag.conversationId ){
        data.aiTagRequestId=this.aiTag.conversationId
        console.log('我是提交的aiTagRequestId',data.aiTagRequestId)
      }
      // console.log(html)
      // console.log(data, 'data')
      if(!this.postModel.willpublish){
        data.willpublishtime=null
      }
      if (parseInt(this.postModel.Id) === 0) {
        this.$axiox.post('/api/Article/Add', data).then(p => {
          if(p.includes('推送时间不可小于')){
            this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: p,
            stayTime: 5
          })
          return
          }

          if (status === 2) {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '提交成功',
              stayTime: 5
            })
            this.$router.push({
              name: 'contentReadAll'
            })
          } else {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '保存成功',
              stayTime: 5
            })
            this.previewContentId = parseInt(p)
            this.postModel.Id = parseInt(p)
            //如果选中 武田&腾讯 保存成功需要返回
            if(this.postModel.articleType == 'FH') {
              this.$router.push({
                name: 'contenList'
              })
            }
            console.log(this.postModel.Id)
          }
        })
      } else {
        data.id = this.postModel.Id

        this.$axiox.post('/api/Article/Checkingbefore', data).then(p=>{
          if(p=="PASS"){
            this.$axiox.post('/api/Article/update', data).then(p => {
              if (status === 2) {
                this.$commonJs.alertTips({
                  type: 'success',
                  title: '成功',
                  content: '提交成功',
                  stayTime: 5
                })
                this.$router.push({
                  name: 'contentReadAll'
                })
              } else {
                this.$commonJs.alertTips({
                  type: 'success',
                  title: '成功',
                  content: '保存成功',
                  stayTime: 5
                })
              if(!this.isSynCOCE)
              {
                this.isSynCDMA = this.isSynCOCE
              }
              let reFlashId = this.previewContentId
              this.previewContentId = 0
              setTimeout(p => {
                this.previewContentId = reFlashId
                setTimeout(p => {
                  ScorllImg()
                }, 3000)
              }, 10)
            }
          })
          }else{
             this.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: p,
              stayTime: 5
            })
            return
          }
        })
        
      }
    },
    addMaterial () {
    },
    SendList () {
      this.userPickerModel = true
    },
    confirUserPicker (e) {
      let emailList = []
      for (let i = 0; i < e.chooseUserList.length; i++) {
        emailList.push(e.chooseUserList[i].email)
      }
      this.$axiox.put('/api/Article/Add/push?contentIds=' + this.previewContentId, emailList).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '发送成功!',
          stayTime: 5
        })
      })
    },
    //点击下一步之后
    nextTo(){
      if(!this.postModel.TitleCN || (!this.ue.getContent()&&!this.ueEn.getContent()) || !this.tagType) {
        return this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
      }else{
        this.aiTag = []
        this.aiTagList = []

        if(this.previewContentId!==0 && this.tagType==='aiTag'){
          //编辑并且点击了下一步
          this.isClickToNext = true
          this.$commonJs.doubleComfirmTwo({
            content: '是否重新进行AI打标签？',
            successFun: msg => {

              this.postModel.articleTagsId = []
              this.postModel.tags = ''
              
              this.isShowApro = true
              this.getAItags(true)
            },
            errorFun: msg => {
              console.log(this.orginAllTagList)
              
              this.allTagList = JSON.parse(JSON.stringify(this.orginAllTagList))
              this.unauditedAItag = []
              //未审核AI标签
              this.detailData.unauditedAITags.forEach(res=>{
                const objs = {
                  name:res.name,
                  isAI:true,
                  checked:true
                }
                this.unauditedAItag.push(objs)
              })

              this.postModel.articleTagsId = this.detailData.articleTagsId
              this.postModel.tags = this.detailData.tags

              this.yshid = []
              this.detailData.manualTags.forEach(res=>{
                if(res.type===1){
                  this.yshid.push(res.id)
                }
              })
              console.log('this.yshid',this.yshid)
              // debugger
              // this.openTagModal()
              this.isShowApro = false
              this.getAItags(false)
            }
          })
          
        }else {
            // 判断标签类型
            if(this.tagType==='recentlyTag'){
              this.allTagList = JSON.parse(JSON.stringify(this.orginAllTagList))
              console.log(this.allTagList)
              
              //常规标签
              this.openTagModal()
            }else{
              this.getAItags(true)
            }
        }
      }
    },
    beforOpenTag(){
      // 判断标签类型
      if(this.tagType==='recentlyTag'){
          //常规标签
          this.openTagModal()
        }else{
          this.getAItags(false)
        }
    },

    // 打开标签弹窗
    openTagModal () {
      
      


      this.isShowParent=true
        
      if (this.allTagList.length > 0 ) {
        let arr = this.postModel.articleTagsId
        let articalTags = this.postModel.tags.split(',')
        console.log(articalTags, 'articalTags')
        
        if(this.previewContentId===0){
          for (let i = 0; i < this.allTagList.length; i++) {
          if(this.allTagList[i].type=="Defualt"){
            if (arr.length > 0) {
              for (let j = 0; j < arr.length; j++) {
                for(let k1=0; k1<this.allTagList[i].customTagChild.length;k1++){
                  if (this.allTagList[i].customTagChild[k1].id == arr[j]) {
                    this.allTagList[i].customTagChild[k1].checked = true
                  }
                }
                
              }
            } else {
              for(let k2=0; k2<this.allTagList[i].customTagChild.length;k2++){
                this.allTagList[i].customTagChild[k2].checked = false               
              }
            }
            for (let k = 0; k < articalTags.length; k++) {
              for(let k1=0; k1<this.allTagList[i].customTagChild.length;k1++){
                if (this.allTagList[i].customTagChild[k1].name == articalTags[k]) {
                  this.allTagList[i].customTagChild[k1].sort = k + 1
                }
              }
              
            }
          }else{
            if (arr.length > 0) {
              for (let j = 0; j < arr.length; j++) {
                if (this.allTagList[i].id == arr[j]) {
                  this.allTagList[i].checked = true
                }
              }
            } else {
              this.allTagList[i].checked = false
            }
            for (let k = 0; k < articalTags.length; k++) {
              if (this.allTagList[i].name == articalTags[k]) {
                this.allTagList[i].sort = k + 1
              }
            }
          }
          
        }
        }

        // 选中的tag
        this.selectedTags = this.allTagList.filter(val => val.checked)
        for(let i=0;i<this.allTagList.length; i++){
          if(this.allTagList[i].type=="Defualt"){
            this.selectedTags=this.selectedTags.concat(this.allTagList[i].customTagChild.filter(val => val.checked))
          }
        }

        

        this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
        this.departmentList = this.allTagList.filter(val => val.type == 'Department')
        this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
        this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
        this.articleFormList = this.allTagList.filter(val => val.type == 'ArticleForm')
        this.contentDirectionList = this.allTagList.filter(val => val.type == 'ContentDirection')


      } else {
        this.selectedTags = []
        this.customTagList = [] // 自定义      
        this.departmentList = [] // 科室
        this.fieldsList = [] // 领域
        this.indicationsList = [] // 适应症
        this.articleFormList = [] // 文章形式
        this.contentDirectionList = [] // 内容方向


      }

      this.customTagShow=this.customTagList
      if(!this.selectedTags.length&&this.departmentList.length || this.previewContentId!==0){
        
        // debugger
        const  selectedTags = localStorage.getItem('JSONselectedTags') || ''
     const  departmentList = localStorage.getItem('JSONdepartmentList') || ''
        
      if(selectedTags && departmentList){
        // this.selectedTags = JSON.parse(selectedTags)
        this.upStrongData(JSON.parse(selectedTags))
        const oldarrs =  JSON.parse(departmentList) 

        // let positions = []
        // let alllist = [...this.departmentList,...this.fieldsList,...this.indicationsList,...this.articleFormList,...this.contentDirectionList]

        this.departmentList.forEach((res,index)=>{
          oldarrs.forEach(item=>{
            if(res.id===item.id&&res.type===item.type){
              this.departmentList[index].checked = true
            }
          })
        })

        this.fieldsList.forEach((res,index)=>{
          oldarrs.forEach(item=>{
            if(res.id===item.id&&res.type===item.type){
              this.fieldsList[index].checked = true
            }
          })
        })

        this.indicationsList.forEach((res,index)=>{
          oldarrs.forEach(item=>{
            if(res.id===item.id&&res.type===item.type){
              this.indicationsList[index].checked = true
            }
          })
        })

        this.articleFormList.forEach((res,index)=>{
          oldarrs.forEach(item=>{
            if(res.id===item.id&&res.type===item.type){
              this.articleFormList[index].checked = true
            }
          })
        })

        this.contentDirectionList.forEach((res,index)=>{
          oldarrs.forEach(item=>{
            if(res.id===item.id&&res.type===item.type){
              this.contentDirectionList[index].checked = true
            }
          })
        })

      //   let positions = this.departmentList.map(obj => {
      //     let index = oldarrs.findIndex(item => item.name === obj.name);
      //     return index;
      // });

      // console.log('-=-=-=',positions)


        
      }
      }

      
     
      this.showTagModal = true
    },
    // 打开AI推荐标签
    getAItags(type){
      if(type){
        this.delAItag = []
        this.unauditedAItag = []
        const productName = this.$route.query.selectContentName
      const categoryId = this.$route.query.selectContentType
      const content =  this.ue.getContent() || this.ueEn.getContent()

      // const loading = Loading.service({
      //   lock: true,
      //   text: 'AI推荐标签获取中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(255, 255, 255, 0.8)',
      //   customClass: 'custom-loading' // 添加自定义类
      // });

    this.showoverlay = true

      this.$axiox.post(`/api/Article/aiTag`,{
        productName,
        categoryId:Number(categoryId),
        content
      },true).then(res => {
        
        console.log('AI标签',res)
        console.log('我是接口的aiTagRequestId',res.conversationId)
        this.aiTag = res
        this.aiTagList = []

        res.tags.forEach(tags=>{
          this.aiTagList.push({
            id:tags.tagId,
            name:tags.tag,
            type:tags.type,
            checked:true,
            isAi:true
          })
        })



        this.otherAItagList = res.other_tags

        if( this.aiTag && this.aiTag.other_tags.length){
        //未审核AI标签
        this.aiTag.other_tags.forEach(res=>{
          
          const objs = {
            name:res.tag,
            isAI:true,
            checked:true
          }
          this.unauditedAItag.push(objs)
        })
      }

        

        this.showoverlay = false
        //AI标签
        this.openTagModalAI()
      }).catch(error=>{
        this.aiTag = null
        this.showoverlay = false
      })
      }else{
        this.openTagModalAI()
      }
      
    },
     // 打开AI标签弹窗
    openTagModalAI(){
      this.isShowParent=true
      
      if (this.allTagList.length > 0) {
        let arr = this.postModel.articleTagsId
        let articalTags = this.postModel.tags.split(',')
        for (let i = 0; i < this.allTagList.length; i++) {
          if(this.allTagList[i].type=="Defualt"){
            if (arr.length > 0) {
              for (let j = 0; j < arr.length; j++) {
                for(let k1=0; k1<this.allTagList[i].customTagChild.length;k1++){
                  if (this.allTagList[i].customTagChild[k1].id == arr[j]) {
                    this.allTagList[i].customTagChild[k1].checked = true
                  }
                }
                
              }
            } else {
              for(let k2=0; k2<this.allTagList[i].customTagChild.length;k2++){
                this.allTagList[i].customTagChild[k2].checked = false               
              }
            }
            for (let k = 0; k < articalTags.length; k++) {
              for(let k1=0; k1<this.allTagList[i].customTagChild.length;k1++){
                if (this.allTagList[i].customTagChild[k1].name == articalTags[k]) {
                  this.allTagList[i].customTagChild[k1].sort = k + 1
                }
              }
              
            }
          }else{
            if (arr.length > 0) {
              for (let j = 0; j < arr.length; j++) {
                if (this.allTagList[i].id == arr[j]) {
                  this.allTagList[i].checked = true
                }
              }
            } else {
              this.allTagList[i].checked = false
            }
            for (let k = 0; k < articalTags.length; k++) {
              if (this.allTagList[i].name == articalTags[k]) {
                this.allTagList[i].sort = k + 1
              }
            }
          }
          
        }

        // 选中的tag
        this.allTagList.forEach(itemA => {
          
            // 如果存在，则将 check 值修改为 true
          if(itemA.customTagChild.length){
            
            itemA.customTagChild.forEach(item1=>{
              const existsInB = this.aiTagList.some(item2 => item2.id === item1.id);
              if (existsInB) {
                item1.checked = true;
                item1.isAI = true;
              }
            })
          }else{
             // 检查 arrayB 中是否存在相同的 id
             const existsInB = this.aiTagList.some(itemB => itemB.id === itemA.id);
            if (existsInB) {
              itemA.checked = true;
              itemA.isAI = true;
            }
          }
            
            
          });

        this.selectedTags = this.allTagList.filter(val => val.checked)
        // this.aiTagList.tagId / id
        // debugger


        for(let i=0;i<this.allTagList.length; i++){
          if(this.allTagList[i].type=="Defualt"){
            this.selectedTags=this.selectedTags.concat(this.allTagList[i].customTagChild.filter(val => val.checked))
          }
        }

        if(this.isClickToNext){
          this.selectedTags.forEach(res=>{
            res.isAI = true

            if(!this.isShowApro) {
              this.yshid.forEach(item=>{
              if(item === res.id){
                res.isAI = false
              }
            })
            } 
            


          })
          
        }

        this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')

        this.departmentList = this.allTagList.filter(val => val.type == 'Department')
        this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
        this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
        this.articleFormList = this.allTagList.filter(val => val.type == 'ArticleForm')
        this.contentDirectionList = this.allTagList.filter(val => val.type == 'ContentDirection')

        // Defualt

        const AIcustomTagList = this.aiTagList.filter(val => val.type == 'Defualt')
        const AIdepartmentList = this.aiTagList.filter(val => val.type == 'Department')
        const AIfieldsList = this.aiTagList.filter(val => val.type == 'Field')
        const AIindicationsList = this.aiTagList.filter(val => val.type == 'Indication')
        const AIarticleFormList = this.aiTagList.filter(val => val.type == 'ArticleForm')
        const AIcontentDirectionList = this.aiTagList.filter(val => val.type == 'ContentDirection')

        this.customTagList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIcustomTagList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.isParent = true;
            }
          });

          this.departmentList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIdepartmentList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.checked = true;
            }
          });

          this.fieldsList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIfieldsList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.checked = true;
            }
          });

          this.indicationsList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIindicationsList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.checked = true;
            }
          });

          this.articleFormList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIarticleFormList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.checked = true;
            }
          });

          this.contentDirectionList.forEach(itemA => {
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = AIcontentDirectionList.some(itemB => itemB.id === itemA.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              itemA.checked = true;
            }
          });

      } else {
        this.selectedTags = []
        this.customTagList = [] // 自定义      
        this.departmentList = [] // 科室
        this.fieldsList = [] // 领域
        this.indicationsList = [] // 适应症
        this.articleFormList = [] // 文章形式
        this.contentDirectionList = [] // 内容方向
      }
      
      

      const diyAItag = this.aiTagList.filter(val => val.type == 'Defualt')
      this.customTagList.forEach(res=>{
        res.customTagChild.forEach(items=>{
            // 检查 arrayB 中是否存在相同的 id
            const existsInB = diyAItag.some(itemB => itemB.id === items.id);
            // 如果存在，则将 check 值修改为 true
            if (existsInB) {
              items.checked = true;
            }
        })
      })

      this.customTagShow=this.customTagList

      // 定义排序顺序
      const order = [
          'Department',
          'Field',
          'Indication',
          'ArticleForm',
          'ContentDirection',
          'Defualt'
      ];

      // 创建一个映射对象，用于获取每个类型的排序索引
      const orderMap = order.reduce((acc, type, index) => {
          acc[type] = index;
          return acc;
      }, {});
      // 对数组进行排序
      this.selectedTags.sort((a, b) => {
        const aIndex = orderMap[a.type] !== undefined ? orderMap[a.type] : Infinity;
    const bIndex = orderMap[b.type] !== undefined ? orderMap[b.type] : Infinity;
    return aIndex - bIndex;
      });
      console.log('this.selectedTags',this.selectedTags)
      // debugger
      this.showTagModalAI = true
    },
    upStrongData(arr){
      // this.selectedTags = []
      this.$axiox.post('/api/Article/GetEmployeeTagCache',arr).then(res => {
        this.selectedTags = res.data
      })
    },
   hasValidCombination (arr) {
  // 遍历所有唯一的三元素组合
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      for (let k = j + 1; k < arr.length; k++) {
        const totalLength =
          arr[i].name.length +
          arr[j].name.length +
          arr[k].name.length;
        if (totalLength <= 20) {
          return true; // 找到符合条件的组合
        }
      }
    }
  }
  return false; // 所有组合均不符合条件
},
    // 确定
    confirmTagModal () {
      
      
      if(this.aiTag&&this.aiTag.approval_no&&this.aiTag.approval_no!=='null'){
        this.postModel.auditNo = this.aiTag.approval_no
        if(this.postModel.auditNo.indexOf('C-APROM')>-1){
          this.isSynCOCE = true
          this.postModel.synC_OCE = 1
          this.postModel.isPromotion = 'False'
        }else if(this.postModel.auditNo.indexOf('C-ANPROM')>-1){
          this.isSynCOCE = true
          this.postModel.synC_OCE = 1
          this.postModel.isPromotion = 'True'
        }
        else{
          this.isSynCOCE = false
          this.postModel.synC_OCE = 0
          this.postModel.isPromotion = ''
        }
      }
      if(this.aiTag&&this.aiTag.approval_date&&this.aiTag.approval_date!=='null'){
        this.postModel.activeTime = this.aiTag.approval_date 
      }
      if(this.aiTag&&this.aiTag.approval_end_date&&this.aiTag.approval_end_date!=='null'){
        this.postModel.inActiveTime = this.aiTag.approval_end_date 
      }



      console.log(this.selectedTags)
      let departmentLen, fieldLen, indicationLen, articleFormLen, contentDirectionLen
      departmentLen = this.selectedTags.filter(p => p.type === 'Department').length
      fieldLen = this.selectedTags.filter(p => p.type === 'Field').length
      indicationLen = this.selectedTags.filter(p => p.type === 'Indication').length
      articleFormLen = this.selectedTags.filter(p => p.type === 'ArticleForm').length
      contentDirectionLen = this.selectedTags.filter(p => p.type === 'ContentDirection').length
      if (!departmentLen || !fieldLen || !indicationLen || !articleFormLen || !contentDirectionLen) {
        return this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '标签中科室、领域、适应症、文章形式、内容方向都至少需要各选一个!',
          stayTime: 5
        })
      }



      if(this.selectedTags.length>0){
        this.isSort = false
        let oldDefualt = []
        let defualtArr = []

        this.selectedTags.forEach(res=>{
          if(res.type==='Defualt'&&oldDefualt.length<3){
            oldDefualt.push(res)
          }
          if(res.type==='Defualt'){
            defualtArr.push(res)
          }
        })
        this.unauditedAItag.forEach(res=>{
          defualtArr.push(res)
        })

        let itemnumber = 0
        oldDefualt.forEach(item=>{
          itemnumber += (item.name.length)
        })

        if(itemnumber>20){
          
          // 前3个标签没满足条件 判断任意组合是否满足
          const isok = this.hasValidCombination(defualtArr)
          if(!isok){
              return this.$commonJs.alertTips({
              type: 'error',
              title: '提示',
              content: '自定义标签字数超限，请重新选择',
              stayTime: 5
            }) 
          }else{
            this.isSort = true
          }
            
        }
        


        let arrsa = []
        this.selectedTags.forEach(res=>{
          if(res.type!=='Defualt'){
            arrsa.push(res)
          }
        })

      


        let arrs = []
        this.departmentList.forEach(res=>{
          
          if(res.checked){
            arrs.push(res)
          }
        })

        this.fieldsList.forEach(res=>{
          if(res.checked){
            arrs.push(res)
          }
        })

        // this.customTagList.forEach(res=>{
        //   if(res.checked){
        //     arrs.push(res)
        //   }
        // })
        this.indicationsList.forEach(res=>{
          if(res.checked){
            arrs.push(res)
          }
        })
        this.articleFormList.forEach(res=>{
          if(res.checked){
            arrs.push(res)
          }
        })
        this.contentDirectionList.forEach(res=>{
          if(res.checked){
            arrs.push(res)
          }
        })

        console.log('arrst',arrs)

        // if(arrs.length>=5){
        //   const newarr = arrs.slice(0,5)
        //   arrs = newarr
        // }
        
        let toSaveArrsa = []
        arrsa.forEach(item=>{
          if(!item.isAI){
            toSaveArrsa.push(item)
          }
        })

        let toSaveArrs = []
        arrs.forEach(item=>{
          if(!item.isAI){
            toSaveArrs.push(item)
          }
        })
        
        console.log('我是要缓存的',toSaveArrsa,toSaveArrs)
        if(this.tagType==='recentlyTag'){
          localStorage.setItem('JSONselectedTags',JSON.stringify(toSaveArrsa))
          localStorage.setItem('JSONdepartmentList',JSON.stringify(toSaveArrs))
        }
        

      }



      this.showTagModal = false
      this.showTagModalAI=false

      this.isTwoNext = true
      this.tagModalData.tabNum = 1

      if (this.selectedTags && this.selectedTags.length > 0) {
        // 去重
        this.selectedTags = Array.from(new Set(this.selectedTags))
        let arr = this.selectedTags.map(val => val.name)
        this.postModel.tags = arr.join(',')
        this.postModel.articleTagsId = this.selectedTags.map(val => val.id)
      } else {
        this.postModel.tags = ''
        this.postModel.articleTagsId = []
      }
    },
    // 取消
    cancelTagModel () {
      this.showTagModal = false
      this.tagModalData.tabNum = 1
      let arr = this.postModel.tags ? this.postModel.tags.split(',') : []
      console.log(arr, 'arr')

      for (let i = 0; i < this.departmentList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.departmentList[i].name == arr[j] && this.departmentList[i].sort > -1) {
              this.departmentList[i].checked = true
            }
          }
        } else {
          this.departmentList[i].checked = false
        }
      }

      for (let i = 0; i < this.fieldsList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.fieldsList[i].name == arr[j] && this.fieldsList[i].sort > -1) {
              this.fieldsList[i].checked = true
            }
          }
        } else {
          this.fieldsList[i].checked = false
        }
      }

      for (let i = 0; i < this.indicationsList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.indicationsList[i].name == arr[j] && this.indicationsList[i].sort > -1) {
              this.indicationsList[i].checked = true
            }
          }
        } else {
          this.indicationsList[i].checked = false
        }
      }

      for (let i = 0; i < this.articleFormList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.articleFormList[i].name == arr[j] && this.articleFormList[i].sort > -1) {
              this.articleFormList[i].checked = true
            }
          }
        } else {
          this.articleFormList[i].checked = false
        }
      }

      for (let i = 0; i < this.contentDirectionList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (this.contentDirectionList[i].name == arr[j] && this.contentDirectionList[i].sort > -1) {
              this.contentDirectionList[i].checked = true
            }
          }
        } else {
          this.contentDirectionList[i].checked = false
        }
      }

      for (let i = 0; i < this.customTagList.length; i++) {
        if (arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            for(let k=0; k<this.customTagList[i].customTagChild.length;k++){
              if (this.customTagList[i].customTagChild[k].name == arr[j] && this.customTagList[i].customTagChild[k].sort > -1) {
                this.customTagList[i].customTagChild[k].checked = true
              }
            }
            
          }
        } else {
          for(let k=0; k<this.customTagList[i].customTagChild.length;k++){
            this.customTagList[i].customTagChild[k].checked = false
          }
          
        }
      }

      if (this.postModel.tags) {
        let arr1 = this.departmentList.filter(item => item.checked && item.sort > -1)
        let arr2 = this.fieldsList.filter(item => item.checked && item.sort > -1)
        let arr3 = this.indicationsList.filter(item => item.checked && item.sort > -1)
        let arr4 = this.articleFormList.filter(item => item.checked && item.sort > -1)
        let arr5 = this.contentDirectionList.filter(item => item.checked && item.sort > -1)
        let arr6 = []
        for(let i = 0; i < this.customTagList.length; i++){
          arr6 = arr6.concat(this.customTagList[i].customTagChild.filter(item => item.checked && item.sort > -1))
        }
        //let arr6 = this.customTagList.filter(item => item.checked && item.sort > -1)
        let selectedArr = [...arr1, ...arr2, ...arr3, ...arr4, ...arr5, ...arr6]
        selectedArr.sort((a, b) => {
          return a.sort - b.sort
        })
        console.log(selectedArr, 'selectedArr')
        // 去重
        this.selectedTags = Array.from(new Set(selectedArr))
        this.postModel.articleTagsId = this.selectedTags.map(val => val.id)
      } else {
        this.selectedTags = []
        this.postModel.articleTagsId = []
      }
    },
    cancelTagModelAI(){
      this.showTagModalAI = false
      if(this.tagType!=='recentlyTag'){
        this.selectedTags = []
        this.aiTagList = []
      }
    },
    // 切换tab
    tabNumChange (num) {
      if (this.tagModalData.tabNum == num) {
        return
      }
      this.tagModalData.tagName = ''
      this.tagModalData.tabNum = num
    },
    // 获取所有标签
    getTagList () {
      let data = {
        // status: 2, // 和全部内容页面传的一样
        name: '',
        department: '',
        fieldId: '',
        indicationId: '',
        userID: this.userInfo.id,
        isOnlyParent: false,
        isadmin: this.isadmin,
        categoryId:  this.postModel.Id == 0?parseInt(this.$route.query.selectContentType):"ED",
        ArticleID:this.postModel.Id,
        type: 0 // Defualt=1,// 普通标签; Department=2,//科室; Indication=3,//适应症; Field=4,//领域; 0=所有
      }
      // console.log(data, 'data+++++++++++++++++++++++++++++++++++++++++++++++')
      let params = {
        pageIndex: 1,
        pageSize: 9999
      }
      let url = this.$commonJs.returnQuery('/api/Article/QueryArticleTagForArticle', data)
      this.$axiox.post(url, params).then(res => {
        console.log(res, '获取标签列表')
        if (res.data && res.data.length > 0) {
          this.allTagList = res.data.map(val => {
            return {
              checked: false,
              sort: -1, // 用于排序
              ...val
            }
          })
          //给子标签加checked和sort
          for(let i=0;i<this.allTagList.length;i++){
            if(this.allTagList[i].customTagChild.length>0){
              for(let j=0;j<this.allTagList[i].customTagChild.length;j++){
                this.allTagList[i].customTagChild[j]={
                  checked: false,
                  sort: -1,
                  ...this.allTagList[i].customTagChild[j]
                }
              }
            }
            
          }
          console.log(this.allTagList, '获取标签列表(加checked和sort属性)')
          this.orginAllTagList = JSON.parse(JSON.stringify(this.allTagList))

          // this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
          // this.departmentList = this.allTagList.filter(val => val.type == 'Department')
          // this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
          // this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
        } else {
          this.allTagList = []
          this.orginAllTagList = []
          // this.customTagList = [] // 自定义
          // this.departmentList = [] //科室
          // this.fieldsList = [] // 领域
          // this.indicationsList = [] // 适应症
        }
      })
    },
    // 选择科室
    chooseDeparment (item) {
      console.log(item, 'chooseDeparment')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 自定义比较函数
    isEqual(obj1, obj2) {
    return obj1.id === obj2.id && obj1.name === obj2.name;
      },
    // 选择全部科室
    setALLdepartment(){

      
      let stnumber = 0
      this.selectedTags.forEach(res=>{
        if(res.type==='Department'){
          stnumber++
        }
      })

      if(stnumber===this.departmentList.length){
        this.isTrueOrFalse = true
      }else{
        this.isTrueOrFalse = false
      }

      
      // this.selectedTags departmentList/type:Department
      let newarr = []
      newarr = this.selectedTags.filter(item => item.type !== 'Department')
      this.selectedTags = JSON.parse(JSON.stringify(newarr))

      if(!this.isTrueOrFalse){
        this.isTrueOrFalse = true
        this.departmentList.forEach(item=>{
          item.checked = true
        })
        this.selectedTags.push(...this.departmentList)
       const newarrs = this.selectedTags.map(JSON.stringify)
          .filter(function(item, index, arr) {
              return arr.indexOf(item) === index;
          })
          .map(JSON.parse);
    this.selectedTags = newarrs
        this.selectedTags.forEach((val, idx) => val.sort = idx)
    console.log(this.selectedTags,this.departmentList)

      }else{
        this.isTrueOrFalse = false
        this.departmentList.forEach(item=>{
          item.checked = false
        })
        // 删除objectArray1中包含在objectArray2中的元素
      let resultArray = this.selectedTags.filter(obj1 => !this.departmentList.some(obj2 => this.isEqual(obj1, obj2)));

        this.selectedTags = resultArray
        console.log(this.selectedTags,this.departmentList)
      }
      // this.departmentList.forEach(item=>{
      //   item.checked = !item.checked
      // })
    },
    // 选择领域
    chooseField (item) {
      console.log(item, 'chooseField')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择适应症
    chooseIndicaton (item) {
      console.log(item, 'chooseIndicaton')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择文章形式
    chooseArticleForm (item) {
      console.log(item, 'chooseArticleForm')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择内容方向
    chooseContentDirection (item) {
      console.log(item, 'chooseIndicaton')
      item.checked = !item.checked
      if (item.checked) {
        this.selectedTags.push(item)
      } else {
        let index = this.selectedTags.findIndex(val => val.name == item.name)
        this.selectedTags.splice(index, 1)
      }
      this.selectedTags.forEach((val, idx) => val.sort = idx)
      console.log(this.selectedTags, 'this.selectedTags')
    },
    // 选择自定义
    chooseCustomeTag (item) {

      
      let namearr = []
        this.selectedTags.forEach(rest=>{
          if(rest.type == 'Defualt'){
            namearr.push(rest)
          }
        })

        if(namearr.length<=2){
          let namelenth = 0
          this.selectedTags.forEach(rest=>{
          if(rest.type == 'Defualt'){
            namelenth+=rest.name.length
          }
        })
        if((namelenth+item.name.length)>20){
            this.$commonJs.alertTips({
              type: 'error',
              title: '提示',
              content: '自定义标签字数超限，请重新选择标签',
              stayTime: 5
            })
            return false
          }
        }
        

      if(item.isParent && item.type=="Defualt"){
        this.customTagShow=item.customTagChild
        this.isShowParent=false
      }else if(!item.isParent && item.type=="Defualt"){

        item.checked = !item.checked
        if (item.checked) {
          this.selectedTags.push(item)
        } else {
          let index = this.selectedTags.findIndex(val => val.name == item.name)
          this.selectedTags.splice(index, 1)
        }
        this.selectedTags.forEach((val, idx) => val.sort = idx)
        console.log(this.selectedTags, 'this.selectedTags')

        


      }
    },
    showParent(){
      this.customTagShow=this.customTagList
      this.isShowParent=true
    },
    // 取消已选择
    cancelSelectedHanlder (item, index) {
      
      this.selectedTags.splice(index, 1)
      const delid = item.id
      this.aiTagList = this.aiTagList.filter(tag => tag.id !== delid);

      // aiTagList

      if (item.type == 'Department') {
        
        for (let i = 0; i < this.departmentList.length; i++) {
          
          if (item.name == this.departmentList[i].name) {
            this.departmentList[i].checked = false
          }
        }
      } else if (item.type == 'Field') {
        for (let i = 0; i < this.fieldsList.length; i++) {
          if (item.name == this.fieldsList[i].name) {
            // item.checked = false
            this.fieldsList[i].checked = false
          }
        }
      } else if (item.type == 'Indication') {
        for (let i = 0; i < this.indicationsList.length; i++) {
          if (item.name == this.indicationsList[i].name) {
            // item.checked = false
            this.indicationsList[i].checked = false
          }
        }
      } else if (item.type == 'ArticleForm') {
        for (let i = 0; i < this.articleFormList.length; i++) {
          if (item.name == this.articleFormList[i].name) {
            // item.checked = false
            this.articleFormList[i].checked = false
          }
        }
      } else if (item.type == 'ContentDirection') {
        for (let i = 0; i < this.contentDirectionList.length; i++) {
          if (item.name == this.contentDirectionList[i].name) {
            // item.checked = false
            this.contentDirectionList[i].checked = false
          }
        }
      } else if (item.type == 'Defualt') {
        for (let i = 0; i < this.customTagList.length; i++) {
          if(this.customTagList[i].customTagChild.length>0){
            for(let j=0; j<this.customTagList[i].customTagChild.length;j++){
              if (item.name == this.customTagList[i].customTagChild[j].name) {
                item.checked = false
              }
            }
            
          }
          
        }
      }
      //console.log(this.selectedTags, 'this.selectedTags1')
    },
    delUnAuditedTag(item, index){
      console.log(item)
      this.delAItag.push(item.name)
      this.unauditedAItag.splice(index,1)
      
    },
    // 获取所有全图文文章
    getMyArticalList (page) {
      this.articalPageIndex = page
      let data = {
        status: this.articalModal.status,
        title: this.articalModal.title,
        creator: this.articalModal.creator,
        categoryId: this.articalModal.categoryId,
        PageIndex: this.articalPageIndex,
        PageSize: 5,
        tags: this.articalModal.tags,
        articleType: this.articalModal.articleType
      }
      let url = this.$commonJs.returnQuery('/api/Article', data)
      this.$axiox.getList(url).then(res => {
        console.log(res, 'getMyArticalList')
        if (res.data && res.data.length > 0) {
          this.myArticalList = res.data
          this.articaltotalCount = res.total
          this.articalTotalPage = Math.ceil(res.total / 5)
        } else {
          this.myArticalList = []
          this.articaltotalCount = 0
          this.articalTotalPage = 0
        }
      })
    },
    openArticalModal () {
      this.selectArticalId = this.postModel.sourceArticleId
      // 获取所有全图文文章
      this.getMyArticalList(1)
      this.showArticalModal = true
    },
    chooseArtical (item) {
      this.selectArticalId = item.id
    },
    confirmArticalModal () {
      let artical = this.myArticalList.filter(val => val.id == this.selectArticalId)
      console.log(artical, 'artical')
      this.postModel.sourceArticleTitle = artical[0].title
      this.postModel.sourceArticleId = this.selectArticalId
      console.log(process.env.config.seviceUrl, 'seviceUrl')
      let url = process.env.config.seviceUrl + '/mobileContent?id=' + this.selectArticalId + `&source=WY`
      console.log(url, 'url')
      // this.postModel.sourceUrl = `https://wechat-dev.takeda.com.cn/api/wechat/oauth2/authorize?redirect_uri=${encodeURIComponent(url)}&response_type=code`
      this.postModel.sourceUrl = process.env.config.baseUrl + `/api/wechat/oauth2/authorize?redirect_uri=${encodeURIComponent(url)}&response_type=code`
      this.showArticalModal = false
    },
    cancelArticalModal () {
      this.showArticalModal = false
      // this.postModel.sourceArticleTitle = ''
      // this.selectArticalId = ''
    },
    // 直接输入原文地址，则清空选择的原文id和title信息
    changeSourceUrl () {
      this.selectArticalId = 0
      this.postModel.sourceArticleTitle = ''
      this.postModel.sourceArticleId = 0
    }
  },
  components: {
    // 'Editor': Editor,
    'contentPreview': contentPreview,
    'surveryList': surveryList,
    'vueCropper': VueCropper
  },
  watch: {
    "postModel.articleType" (newData) {
      console.log(newData, 'postModel.articleType')
      if (newData == 'H' || newData == 'FH') {
        this.postModel.isshowurl = true
      } else {
        this.postModel.isshowurl = false
        this.postModel.sourceUrl = ''
      }
    },
    "tagModalData.tagName" (newData) {
      this.tagModalData.tagName = newData.trim()
      console.log(this.tagModalData.tagName, 'this.tagModalData.tagName')
      for (let i = 0; i < this.selectedTags.length; i++) {
        for (let j = 0; j < this.allTagList.length; j++) {
          if (this.selectedTags[i].id == this.allTagList[j].id) {
            this.allTagList[j].checked = true
          }
        }
      }
      this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
      this.departmentList = this.allTagList.filter(val => val.type == 'Department')
      this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
      this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
      this.articleFormList = this.allTagList.filter(val => val.type == 'ArticleForm')
      this.contentDirectionList = this.allTagList.filter(val => val.type == 'ContentDirection')
      if (this.tagModalData.tagName) {
        let str = this.tagModalData.tagName
        if (this.tagModalData.tabNum == 1) {
          let fullList = JSON.parse(JSON.stringify(this.departmentList))
          // 如果是科室tab
          let list = this.departmentList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索科室')
          this.departmentList = list
        } else if (this.tagModalData.tabNum == 2) {
          // 如果是领域tab
          let list = this.fieldsList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索领域')
          this.fieldsList = list
        } else if (this.tagModalData.tabNum == 3) {
          // 如果是适应症tab
          let list = this.indicationsList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索适应症')
          this.indicationsList = list
        } else if (this.tagModalData.tabNum == 4) {
          // 如果是文章形式tab
          let list = this.articleFormList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索文章形式')
          this.articleFormList = list
        } else if (this.tagModalData.tabNum == 5) {
          // 如果是内容方向tab
          let list = this.contentDirectionList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索内容方向')
          this.contentDirectionList = list
        } else if (this.tagModalData.tabNum == 6) {
          // 如果是自定义tab
          let list = this.customTagList.filter(item => item.name.indexOf(str) > -1)
          console.log(list, '搜索自定义')
          this.customTagList = list
        }
      } else {
        console.log(this.selectedTags, 'selectedTags')
        // 获取所有标签
        this.getTagList()
        for (let i = 0; i < this.selectedTags.length; i++) {
          for (let j = 0; j < this.allTagList.length; j++) {
            if (this.selectedTags[i].id == this.allTagList[j].id) {
              this.allTagList[j].checked = true
            }
          }
        }
        this.customTagList = this.allTagList.filter(val => val.type == 'Defualt')
        this.departmentList = this.allTagList.filter(val => val.type == 'Department')
        this.fieldsList = this.allTagList.filter(val => val.type == 'Field')
        this.indicationsList = this.allTagList.filter(val => val.type == 'Indication')
        this.articleFormList = this.allTagList.filter(val => val.type == 'ArticleForm')
        this.contentDirectionList = this.allTagList.filter(val => val.type == 'ContentDirection')
      }
      this.customTagShow=this.customTagList
    }
  }
}
function ScorllImg () {
  clearInterval(setIntervalImg)
  scorllData = []
  let imgDomList = document.querySelectorAll('.myScorllImgPlace')
  for (let i = 0; i < imgDomList.length; i++) {
    scorllData.push(0)
  }
  setIntervalImg = setInterval(P => {
    for (let i = 0; i < scorllData.length; i++) {
      if (imgDomList[i]) {
        scorllData[i]++
        let dotList = imgDomList[i].querySelectorAll('.dot')
        for (let j = 0; j < dotList.length; j++) {
          dotList[j].classList.remove('active')
        }
        if (scorllData[i] > imgDomList[i].querySelectorAll('.showPlace img').length - 1) {
          scorllData[i] = 0
        }
        if (imgDomList[i].querySelector('.showPlace')) {
          imgDomList[i].querySelector('.showPlace').style.left = (-100 * scorllData[i] + '%')
          dotList[scorllData[i]].classList.add('active')
        }
      }
    }
  }, 3000)
}
</script>

<style scoped>
tr.choosed td{
  background: #FF7F41;
  color: #fff;
}
#editContList {
  margin-top: -65px;
}
.bottom {
  color: red;
  position: relative;
  bottom: -55px;
}
/*.t_r{*/
/*  margin-right: 360px;*/
/*}*/
#ueditor {
  min-height: 300px;
}
#ueditor2 {
  min-height: 300px;
}
.input {
  width: calc(100% - 100px);
  margin-left: 100px;
  position: relative;
}

.m_b_5 {
  margin-left: -80px;
  margin-bottom: -20px;
}

.rightTo {
  right: 20px;
}
.myTag-box {
  border: 1px solid #ee1100;
  border-radius: 10px;
  min-height: 120px;
  overflow: auto;
  max-height: 180px;
}
.myTag-box .title {
  font-size: 14px;
  color: rgb(137,137,137);
  display: inline-block;
  float: left;
  width: 10%;
  padding: 5px 0;
  margin-top: 10px;
  text-align: center;
}
.myTag-box .selected-tags {
  width: auto;
  text-align: center;
  display: inline-block;
  color: #fff;
  background-color: #ee1100;
  border-radius: 30px;
  float: left;
  padding: 5px 15px;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 2px 6px -2px rgba(255, 0, 0, 0.6);
  box-sizing: border-box;
  padding-right: 8px;
}
.myTag-box .selected-AItags {
  width: auto;
  text-align: center;
  display: inline-block;
  color: #ee1100;
  background-color: #FFF;
  border-radius: 30px;
  float: left;
  padding: 5px 15px;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 2px 6px -2px rgba(255, 0, 0, 0.6);
  box-sizing: border-box;
  padding-right: 8px;
}


.myTag-box .selected-tags:first-child {
  margin-left: 0!important;
}
.myTag-box .selected-AItags:first-child {
  margin-left: 0!important;
}
.tags-topTag {
  text-align: center;
  width: 120px;
  padding: 5px 0;
  display: inline-block;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.activedTags-topTag {
  background-color: #FFF2EC;
  color: #ee1100;
  box-shadow: 0px -5px 9px -3px rgba(76,73,72, 0.1);
}
.allTag-box {
  margin-top: 15px;
}
.sonTag {
  border-radius: 0 10px 10px 10px;
  background-color: #FFF2EC;
  min-height: 200px;
  overflow: hidden;
  /* padding: 0 6px; */
  box-sizing: border-box;
  box-shadow: 0px 8px 6px -3px rgba(76,73,72, 0.1);
}
.searchTag {
  margin-top: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
}
.plain-tags {
  width: auto;
  /* width: 10%; */
  /* height: 26px; */
  /* line-height: 30px; */
  text-align: center;
  display: inline-block;
  border: 1px solid rgb(76,73,72);
  color: rgb(76,73,72);
  border-radius: 30px;
  float: left;
  padding: 5px 15px;
  margin: 10px;
  cursor: pointer;
  box-shadow: 0px 2px 6px -2px rgba(76,73,72, 0.6);
  box-sizing: border-box;
}
.checked-tags {
  border: 1px solid #ee1100!important;
  color: #ee1100!important;
  box-shadow: 0px 2px 6px -2px rgba(255, 0, 0, 0.6);
}
.thisCanderDiv >>> .canderDiv{
  z-index: 99999!important;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 210px;
    height: 210px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/editContList.vue